/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

import {
  createItem,
  slugify,
  createButton,
} from '../../../../src/core/dataitems'

import dayjs from 'dayjs'
const thisYear = dayjs().year()

export const pages = {
  'confirm-cancel': {
    modal: true,
    text: [],
    buttons: [
      { label: 'Yes', id: 'yes', uid: '0baa62eba1b1a7d7', control: true },
      { label: 'No', id: 'no', uid: '6c0e0e2956ec3933', control: true },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '9bc15702a2e49228',
      content: ['Are you sure you want to cancel this application?'],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'quotation-screen': {
    text: [],
    buttons: [
      {
        label: 'Add family',
        id: 'add-family',
        uid: '4944cc6ab7d9e98c',
        control: false,
      },
      {
        label: 'Remove family',
        id: 'remove-family',
        uid: 'a5ca5df087270493',
        control: false,
      },
      {
        label: 'Edit family',
        id: 'edit-family',
        uid: '0d437aba38a8517f',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'quote-screen',
      type: 'list',
      readonly: false,
      label: 'Quote Screen',
      uid: 'cce3868dbff643df',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '552d19e7a2f676a3',
          content: '<h2>Choose your cover</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'a1fcd090d9138ba4',
          content:
            '<p>To be able to provide you with a quick quotation we will need the following information from you.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '56dfc210727e82c4',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'your-details',
          type: 'list',
          readonly: false,
          label: 'Your Details',
          uid: 'cd430b0232f45f0a',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'b85bf420db7a7753',
              content: '<p>When were you born?</p>\n',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: 'f0e0a8a867c4bd0c',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'date',
              component: 'DateSelector',
              maxYear: thisYear,
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '36a48639064fc078',
              content: '<p>What is your gender?</p>\n',
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'radio',
              readonly: false,
              label: 'Gender',
              uid: 'a8a4db22b3901177',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: ['Female', 'Male'],
            },
          ],
        },
        {
          id: 'cover-options',
          type: 'list',
          readonly: false,
          label: 'Cover Options',
          uid: 'b95c591446e6ddf9',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '98c0a67661f71562',
              content: '<p>What cover option would you like?</p>\n',
            },
            {
              id: 'main-plan-type-radio-group',
              type: 'list',
              readonly: false,
              label: 'Main Plan Type Radio Group',
              uid: '1db6c8a99b05c77a',
              content: [
                {
                  id: 'ghs-1000000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 10000.00',
                  uid: '6949b58f25b81f9c',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-1500000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 15000.00',
                  uid: 'a00ee8a06aa09dd0',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-2000000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 20000.00',
                  uid: 'ca82cfa399dfeb91',
                  content: 'N',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-2500000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 25000.00',
                  uid: '2faa5256865970f1',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-3000000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 30000.00',
                  uid: '7d8176f17bf75534',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-5000000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 50000.00',
                  uid: '4a944312a742daad',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-7000000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 70000.00',
                  uid: '2881158a26e0ff54',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'ghs-10000000',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'GHS 100000.00',
                  uid: '170eae7139c11411',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
          ],
        },
        {
          id: 'your-family',
          type: 'list',
          readonly: true,
          label: 'Your Family',
          uid: 'a35e2aad7f7eefa4',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '43d546ee054c0715',
              content:
                '<p>Do you want to cover any of your family members under this benefit?</p>\n',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '0baf0a4311836cb7',
              content:
                '<p>Please note that this will increase your premium accordingly.</p>\n',
            },
            {
              id: 'lives-added-basic',
              type: 'table',
              readonly: true,
              label: 'Lives Added Basic',
              uid: '35a4fe74404d1ff6',
              columns: [],
              content: [],
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'e9bba8eeff937b49',
              content: "<p><a href='#add-family'>Add Member</a></p>\n",
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'fa1af3e470c15300',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'f73d657188dcf60b',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '1950b77bcdb17d60',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'f20aba0e17ed86fa',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '2e71b32f3296dcea',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Policyholder Quick Quote',
    uri: 'transition/policyholder-quick-quote',
    template: 'transition-app-template',
    class: 'transition-policyholder-quick-quote',
  },
  'premium-amount': {
    text: [],
    buttons: [
      {
        label: 'Done',
        id: 'done',
        uid: '4e5f7031a7643ff6',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '7610709cfc53af91',
      content: [
        'The minimum premium is 50. Please select another plan type or add more lives assured in order to meet this requirement.',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Policyholder Quick Quote',
    uri: 'transition/policyholder-quick-quote',
    class: 'transition-policyholder-quick-quote',
  },
  'add-family-members': {
    modal: true,
    text: [],
    buttons: [],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '178b7838c3fade6d',
      content: [
        ' Please specify your relationship to the life you want to add.',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'family-members-age-and-gender': {
    modal: true,
    text: ['Please provide the age and gender of your spouse'],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
    ],
    item: {
      id: 'additional-family-details',
      type: 'list',
      readonly: false,
      label: 'Additional Family Details',
      uid: '4c87084fb0a64199',
      content: [
        {
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: '9a07e60b5bba99b8',
          content: '<p></p>\n',
        },
        {
          id: 'age-of-member',
          type: 'integer',
          elementType: 'select',
          readonly: false,
          label: 'Age Of Member',
          uid: '31635e1db55cb34c',
          content: '',
          publishChange: true,
          errors: ['*'],
          tooltip: 'Age Of Member',
          options: [],
        },
        {
          id: 'gender',
          type: 'field',
          elementType: 'radio',
          readonly: false,
          label: 'Gender',
          uid: 'defa6021f5cbe751',
          content: '',
          publishChange: true,
          errors: ['*'],
          tooltip: 'Gender',
          options: ['Female', 'Male'],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'edit-family-members': {
    modal: true,
    text: [],
    buttons: [],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '4981e8376bfbfbd8',
      content: [
        'Please select the person whose details you would like to edit',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'remove-family-members': {
    modal: true,
    text: [],
    buttons: [
      {
        label: '',
        id: '',
        uid: 'bfb0a1ef332e5a00',
        control: false,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '4981e8376bfbfbd8',
      content: [
        'Please select the person you would like to remove from the policy',
      ],
    },
    title: 'Public Access \n Welcome to Elac',
  },
  'personal-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'personal-details',
      type: 'list',
      readonly: false,
      label: 'Personal Details',
      uid: '6889d4774b4e4b8f',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'c9d124707f9d1b14',
          content: '<h2>Personal Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'a8902e1cd0cee07e',
          content:
            '<p>For us to complete the purchase, we require the following information</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '3dfdc74464a34aa8',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'your-details',
          type: 'list',
          readonly: false,
          label: 'Your Details',
          uid: 'aa849fc048832acb',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: '6b7ca958d9ea364b',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: '464b64f4d28fd6b9',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'idpassport-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ID/Passport Number',
              uid: '98e2671fcd68feeb',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: 'cf5112787e541dd8',
              content: '',
              publishChange: true,
              inputType: 'date',
              component: 'DateSelector',
              maxYear: thisYear,
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: 'df961919bc248ac4',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Title',
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'marital-status',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Marital Status',
              uid: 'b7787bd9a19e2138',
              content: '',
              publishChange: true,
              tooltip: 'Marital Status',
              options: [
                '',
                'Divorced',
                'Married',
                'Single',
                'Widow',
                'Widower',
              ],
            },
            {
              id: 'ghanaian',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Ghanaian',
              uid: 'baf950dbec76f0ef',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
            {
              id: 'other-nationality',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Other Nationality',
              uid: '3e4c1392a502afef',
              content: '',
              publishChange: true,
              tooltip: 'Other Nationality',
              options: [
                '',
                'Afghan',
                'Albanian',
                'Algerian',
                'American',
                'Andorran',
                'Angolan',
                'Argentine',
                'Armenian',
                'Aromanian',
                'Aruban',
                'Australian',
                'Austrian',
                'Azerbaijani',
                'Bahamian',
                'Bahraini',
                'Baltic German',
                'Baltic Russian',
                'Bangladeshi',
                'Barbadian',
                'Belarusian',
                'Belgian',
                'Belizean',
                'Bermudian',
                'Boer',
                'Bosniak',
                'Brazilian',
                'Breton',
                'British',
                'British Virgin Islander',
                'Bruneian',
                'Bulgarian',
                'Burkinabè',
                'Burundian',
                'Cambodian',
                'Cameroonian',
                'Canadian',
                'Cape Verdean',
                'Catalan',
                'Chadian',
                'Chilean',
                'Chinese',
                'Colombian',
                'Comorian',
                'Congolese',
                'Croatian',
                'Cuban',
                'Cypriot',
                'Czech',
                'Dane',
                'Dominican (Commonwealth)',
                'Dominican (Republic)',
                'Dutch',
                'East Timorese',
                'Ecuadorian',
                'Egyptian',
                'Emirati',
                'English',
                'Eritrean',
                'Estonian',
                'Ethiopian',
                'Falkland Islander',
                'Faroese',
                'Fijian',
                'Filipino',
                'Finn',
                'Finnish Swedish',
                'French Citizen',
                'Georgian',
                'German',
                'Ghanaian',
                'Gibraltar',
                'Greek',
                'Greek Macedonian',
                'Grenadian',
                'Guatemalan',
                'Guianese (French)',
                'Guinea Bissau National',
                'Guinean',
                'Guyanese',
                'Haitian',
                'Honduran',
                'Hong Kong',
                'Hungarian',
                'I Kiribati',
                'Icelander',
                'Indian',
                'Indonesian',
                'Iranian',
                'Iraqi',
                'Irish',
                'Israeli',
                'Italian',
                'Ivoirian',
                'Jamaican',
                'Japanese',
                'Jordanian',
                'Kazakh',
                'Kenyan',
                'Korean',
                'Kosovar',
                'Kurd',
                'Kuwaiti',
                'Kyrgyz',
                'Lao',
                'Latvian',
                'Lebanese',
                'Liberian',
                'Libyan',
                'Liechtensteiner',
                'Lithuanian',
                'Luxembourger',
                'Macedonian',
                'Macedonian Bulgarian',
                'Malagasy',
                'Malawian',
                'Malaysian',
                'Maldivian',
                'Malian',
                'Maltese',
                'Manx',
                'Mauritian',
                'Mexican',
                'Moldovan',
                'Mongolian',
                'Montenegrin',
                'Moroccan',
                'Namibian',
                'Nepalese',
                'New Zealander',
                'Nicaraguan',
                'Nigerian',
                'Nigerien',
                'Norwegian',
                'Other',
                'Pakistani',
                'Palauan',
                'Palestinian',
                'Panamanian',
                'Papua New Guinean',
                'Paraguayan',
                'Peruvian',
                'Pole',
                'Portuguese',
                'Puerto Rican',
                'Qatari',
                'Romanian',
                'Russian',
                'Rwandan',
                'Salvadoran',
                'Saudi',
                'Scot',
                'Senegalese',
                'Serb',
                'Sierra Leonean',
                'Sindhian',
                'Singaporean',
                'Slovak',
                'Slovene',
                'Somali',
                'Somalilander',
                'South African',
                'Spaniard',
                'Sri Lankan',
                'St Lucian',
                'Sudanese',
                'Surinamese',
                'Swede',
                'Swiss',
                'Syriac',
                'Syrian',
                'São Tomé And Príncipe',
                'Taiwanese',
                'Tajik',
                'Tanzanian',
                'Thai',
                'Tibetan',
                'Tobagonian',
                'Trinidadian',
                'Tunisian',
                'Turk',
                'Turkish Cypriot',
                'Tuvaluan',
                'Ugandan',
                'Ukrainian',
                'United States',
                'Uruguayan',
                'Uzbek',
                'Vanuatuan',
                'Venezuelan',
                'Vietnamese',
                'Welsh',
                'Yemeni',
                'Zambian',
                'Zimbabwean',
              ],
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'radio',
              readonly: false,
              label: 'Gender',
              uid: '72e95c05ec4cf91a',
              content: 'Female',
              publishChange: true,
              tooltip: 'Gender',
              options: ['Female', 'Male'],
            },
            {
              id: 'id-type-radio-group',
              type: 'list',
              readonly: false,
              label: 'ID Type Radio Group',
              uid: '55144de6e5b38f62',
              content: [
                {
                  id: 'dvla',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Dvla',
                  uid: 'bc235e8781bbe982',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'passport',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Passport',
                  uid: 'e59e68b8ac36a00f',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'voter-id',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Voter ID',
                  uid: '9215dbff34ced1f3',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'nhis',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Nhis',
                  uid: 'c0bebf727748350e',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'ssnit',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Ssnit',
                  uid: 'f79d0cafc5c371cd',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'nia-ghana-card',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Nia Ghana Card',
                  uid: '44966d1518c74a13',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
              ],
              errors: ['*'],
            },
          ],
        },
        {
          id: 'your-contact-details',
          type: 'list',
          readonly: false,
          label: 'Your Contact Details',
          uid: '0e1e67869d216021',
          content: [
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: '43bb2ffb6f6594b6',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'email',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Email',
              uid: '1c7c3b04cdd13345',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'email',
            },
          ],
        },
        {
          id: 'your-postal-address',
          type: 'list',
          readonly: false,
          label: 'Your Postal Address',
          uid: '86340be1fcf81958',
          content: [
            {
              id: 'addressee',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Addressee',
              uid: '9b05ac387f64d6b8',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'po-box-or-private-bag',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'PO Box Or Private Bag',
              uid: '31bbec7a6c188206',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'region',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Region',
              uid: 'f9534e4ceabbdd80',
              content: '',
              publishChange: true,
              errors: ['*'],
              tooltip: 'Region',
              options: [
                '',
                'Ahafo',
                'Ashanti',
                'Bono East',
                'Brong Ahafo',
                'Central',
                'Eastern',
                'Greater Accra',
                'North East',
                'Northern',
                'Oti',
                'Savannah',
                'Upper East',
                'Upper West',
                'Volta',
                'Western',
                'Western North',
              ],
            },
            {
              id: 'town',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Town',
              uid: 'f65c4a97d4bee5a0',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Abamasarefan',
                'Abandze',
                'Abaoba',
                'Abasa',
                'Abasa Ajumaku',
                'Abasi',
                'Abdulaikrom',
                'Abease',
                'Abenasi',
                'Abene',
                'Abesem',
                'Ablornu',
                'Aboabo No 2',
                'Abodom',
                'Abofoo',
                'Aboma',
                'Abomoso',
                'Abompe',
                'Aboo',
                'Abooso',
                'Abora',
                'Abora Oboasi',
                'Abore',
                'Abra',
                'Abrekum',
                'Abuakwa',
                'Abuom',
                'Abura Dunkwa',
                'Aburi',
                'Abutia - Kloe',
                'Accra',
                'Achawa Pt.',
                'Achiase',
                'Achimota',
                'Ada',
                'Adabokurom',
                'Adaiso',
                'Adansi',
                'Adawsu',
                'Adidakpavui',
                'Adidome',
                'Adidwan',
                'Adina',
                'Adjena',
                'Adobo',
                'Adonso',
                'Aduaben',
                'Aduamoa',
                'Adubea',
                'Adubiliyili',
                'Adukrom',
                'Adumadum',
                'Adwamadiem',
                'Adwufia',
                'Adwum',
                'Adzakoe',
                'Afegame',
                'Afiaso',
                'Afienya',
                'Aflao',
                'Afosu',
                'Aframso',
                'Afratwo',
                'Agogo',
                'Agona',
                'Agona Nkwanta',
                'Aguna',
                'Agyana',
                'Ahamasu',
                'Ahebensu',
                'Ahemakurom',
                'Ahenkro',
                'Ahobre',
                'Ahunda',
                'Ahwerewa',
                'Ahwiren',
                'Aiyiribi',
                'Ajemra',
                'Ajumako',
                'Ajumaku',
                'Akantansu',
                'Akanu',
                'Akatsi',
                'Akim Oda',
                'Akim Swedru',
                'Akim Tafo',
                'Akoasi',
                'Akontaanim',
                'Akontanim',
                'Akoroso',
                'Akosombo',
                'Akosombo Juapon',
                'Akpabanya',
                'Akra',
                'Akrofuom',
                'Akrokerri',
                'Akropon',
                'Akropong',
                'Akumadan',
                'Akuntuase',
                'Akuse',
                'Akwantonbra',
                'Akwidaa',
                'Akyekyere',
                'Akyemfo Gyomuro',
                'Alenda',
                'Amamsi',
                'Amankwakrom',
                'Amasaman',
                'Amasu',
                'Ambo',
                'Amedzofe',
                'Amenfi',
                'Amlakpo',
                'Amoama',
                'Amoma',
                'Amoya',
                'Ampeda',
                'Ampeyoo',
                'Anfoaga',
                'Anibil',
                'Ankaasi',
                'Ankaful',
                'Ankan',
                'Anloga',
                'Anomabo',
                'Antabia',
                'Anum',
                'Anyaboni',
                'Anyako',
                'Anyanui',
                'Anyinam',
                'Anyinasu',
                'Anyirawase',
                'Aobo Aduamoa',
                'Apam',
                'Apapasu',
                'Apataim',
                'Aperade',
                'Apesokubi',
                'Apinso',
                'Apowa',
                'Asaafa',
                'Asaam',
                'Asaaman',
                'Asafo',
                'Asakraka',
                'Asamankese',
                'Asankrangua',
                'Asantekrom',
                'Asasitre',
                'Asatowe',
                'Asawinso',
                'Asebu',
                'Asekore',
                'Asesewa',
                'Ashanti',
                'Asiakwa',
                'Asiekpe',
                'Asikuma',
                'Assin Breku',
                'Assin Manso',
                'Assin Nyankumase',
                'Assin Praso',
                'Asuboa',
                'Asuderi',
                'Asukawkaw',
                'Asumenya',
                'Asunafo',
                'Asuom',
                'Asuotiano',
                'Asutsuare',
                'Ataase',
                'Atebubu',
                'Atesa',
                'Atiavi',
                'Atieku',
                'Atimpoku',
                'Atobase',
                'Atuabo',
                'Atuna',
                'Ave-afiadenyiga',
                'Ave-dakpa',
                'Avenorpeme',
                'Aveyime',
                'Awatia',
                'Awisa',
                'Awisan',
                'Awonakrom',
                'Awurasa',
                'Awutu',
                'Axim',
                'Ayanfure',
                'Ayerede',
                'Ayiase',
                'Ayiem',
                'Ayikuma',
                'Ayinwafe',
                'Ayomfo',
                'Baabiaraneha',
                'Baaglo',
                'Baantama',
                'Babile',
                'Babopi',
                'Bagape',
                'Bagbiapi',
                'Bagmare',
                'Bagurugu',
                'Bagwiwu',
                'Baika',
                'Bakanta',
                'Bakau',
                'Bakoniaba',
                'Bale',
                'Bamboi',
                'Banaso',
                'Banda',
                'Banda - Nkwanta',
                'Bandae',
                'Bandiyili',
                'Bangwan',
                'Banko',
                'Bansang',
                'Banso',
                'Banu',
                'Barae No 2',
                'Barra',
                'Basa',
                'Basie',
                'Basse',
                'Battor',
                'Batume Junction',
                'Bau',
                'Bawdie',
                'Bawiesibal',
                'Bawjiase',
                'Bawka',
                'Bawku',
                'Bechem',
                'Bediakokurom',
                'Begoro',
                'Beku',
                'Bekwai',
                'Bende',
                'Benso',
                'Beposo',
                'Berekum',
                'Berekuso',
                'Besease',
                'Beyin',
                'Biadam',
                'Bibiani',
                'Bielikpang',
                'Billaw',
                'Bimbago',
                'Bimbagokpasenkpe',
                'Bimbagu',
                'Bimbila',
                'Binaba',
                'Binduri',
                'Bisa',
                'Biung',
                'Boanim',
                'Bodi',
                'Bodwesango',
                'Bofaso',
                'Bogdoo',
                'Bogorono',
                'Bogorop',
                'Bogoso',
                'Bole',
                'Bolgatanga',
                'Bombori',
                'Bomburi Fimbo',
                'Bomfa',
                'Bonakye',
                'Bongo',
                'Bonkrom',
                'Bonohoma',
                'Bonyere',
                'Booyem',
                'Bopa',
                'Boro',
                'Bortianor',
                'Bososo',
                'Bowiri',
                'Brakwa',
                'Branam',
                'Brenase',
                'Bresuanu',
                'Brewaniase',
                'Brikama',
                'Brikamaba',
                'Brofuyedru',
                'Brufut',
                'Brugbani',
                'Buachipe',
                'Buaka',
                'Bugri',
                'Bugu',
                'Buipe',
                'Bukanor',
                'Bulangsa',
                'Bulangsa Torsa',
                'Bulenga',
                'Bungeli',
                'Bunkpurugu',
                'Burai',
                'Busa',
                'Busie',
                'Busunu',
                'Butie',
                'Buya',
                'Cape Coast',
                'Cape St. Paul',
                'Cape Three Pts.',
                'Carnpaga Sakogu',
                'Chache',
                'Chaisa',
                'Chama',
                'Chamba',
                'Changbuni',
                'Chanyili',
                'Chase',
                'Chatali',
                'Chemfe',
                'Chepuri',
                'Cherepon',
                'Cheropon',
                'Chia',
                'Chiana-asuma',
                'Chichari',
                'Christiansborg',
                'Chuchiliga',
                'Dabala',
                'Daboase',
                'Dabori',
                'Dabova',
                'Daboya',
                'Dadeeso',
                'Dado',
                'Dadwen',
                'Dafiama',
                'Dafo',
                'Dafor',
                'Dagonkadi',
                'Dakpam',
                'Damanko',
                'Dambai',
                'Damongo',
                'Danko',
                'Dapa',
                'Dasanyi',
                'Datako-kurbor',
                'Datano',
                'Dawa',
                'Dawadawa',
                'Dawhenya',
                'Debiribi',
                'Debiso',
                'Dedeso Wireko',
                'Degbila',
                'Dego',
                'Demoh',
                'Dena',
                'Denkyira',
                'Densubon',
                'Denu',
                'Diabakurom',
                'Diari',
                'Diasempa',
                'Diaso',
                'Digma',
                'Digmamandari',
                'Disiga',
                'Dixcove',
                'Dodowa',
                'Dogokrom',
                'Domeabra',
                'Domenase',
                'Dominase',
                'Dompem',
                'Dompoase',
                'Doninga',
                'Donkponkwanta',
                'Doriman',
                'Dormaa-ahenk',
                'Doryum',
                'Drakofe',
                'Drobo',
                'Dromakese',
                'Duaburori',
                'Duadaso',
                'Duie',
                'Dukusen',
                'Dumienu',
                'Dunkwa',
                'Dunkwa On Offin',
                'Duu',
                'Dwija',
                'Dwokwa',
                'Dyayaw-nkwanta',
                'Dzana',
                'Dzita',
                'Dzodze',
                'Effiduase',
                'Eikwe',
                'Ejian',
                'Ejisu',
                'Ejura',
                'Ekumdipe',
                'Ekuropon',
                'Ekyiamenfurom',
                'Elmina',
                'Elubo',
                'Enchi',
                'Enyan',
                'Enyanmansu',
                'Enyinabrim',
                'Esaaman',
                'Esalikawu',
                'Essem',
                'Essiama',
                'Esuakrom',
                'Fajara',
                'Fanti',
                'Farafenni',
                'Farifari',
                'Fawamam',
                'Fenyi Yokoe',
                'Feo-nabisi',
                'Fete',
                'Fetenta',
                'Fian',
                'Fianko',
                'Fimbo',
                'Fomena',
                'Foso',
                'Frankadua',
                'Fuchmbluma',
                'Fufulsu',
                'Fufuo',
                'Fumbisi',
                'Fumsi',
                'Fumso',
                'Fuu',
                'Ga',
                'Gaa',
                'Gambia No 1',
                'Gambia No 2',
                'Gbal',
                'Gbalga',
                'Gbangdaa',
                'Gbantala',
                'Gbari',
                'Gbasinkpa',
                'Gbateto',
                'Gbedema',
                'Gbeini',
                'Gbemfo',
                'Gbeni',
                'Gbimsi',
                'Gbogu',
                'Gbulumpe',
                'Gbung',
                'Gida',
                'Gitase',
                'Gnani',
                'Goantala',
                'Goaso',
                'Goka',
                'Gokoron',
                'Golokuati',
                'Gonnokurom',
                'Gorgu',
                'Gpapga',
                'Grube',
                'Grupe',
                'Gulibikomonpa',
                'Guri',
                'Guru-natinga',
                'Gushie',
                'Gwallo',
                'Gwellukupulima',
                'Gwo',
                'Gwosi',
                'Gyapa',
                'Gyedua',
                'Gyekiti',
                'Gyema',
                'Gyenegyene',
                'Half Assini',
                'Hamale',
                'Harglakarpe',
                'Have Etoe',
                'Helu',
                'Heluivi',
                'Heman',
                'Hevi',
                'Hian',
                'Hiawoanwu',
                'Ho',
                'Hohoe',
                'Honuta',
                'Huhunya',
                'Hunt Valley',
                'Huntodo',
                'Hwidiem',
                'Imbraim',
                'Issa',
                'Jaba',
                'Jadima',
                'Jafor',
                'Jakai',
                'Jakobo',
                'Jamasi',
                'Jamra',
                'Jandra',
                'Jang',
                'Janjangbureh',
                'Jasikan',
                'Jato',
                'Jawani',
                'Jeffisi',
                'Jegbuni',
                'Jeinsusa',
                'Jema',
                'Jemile',
                'Jerigu',
                'Jeshwang',
                'Jewi Wharf',
                'Jeyiri',
                'Jimdabuo',
                'Jinfranukasuridabarshe',
                'Jinpasi',
                'Jirapa',
                'Jogboi',
                'Jombo',
                'Juaben',
                'Juabeso',
                'Juana',
                'Juapon',
                'Juaso',
                'Jumo',
                'Junle',
                'Juo',
                'Kaase',
                'Kabaka',
                'Kablima',
                'Kabonwele',
                'Kade',
                'Kadema',
                'Kadjebi',
                'Kafaba',
                'Kafodzidzi',
                'Kafuta',
                'Kakawere',
                'Kakorasua',
                'Kakum',
                'Kalagie',
                'Kalba',
                'Kaleo',
                'Kalini',
                'Kamsorio',
                'Kananta',
                'Kandige',
                'Kanga',
                'Kanifing',
                'Kanilie',
                'Kanjaga',
                'Kanseri',
                'Kantani',
                'Kanyaga',
                'Kapro',
                'Kapua',
                'Karaga',
                'Karamenga',
                'Karni',
                'Kasa',
                'Kasapen',
                'Kasoa',
                'Kasuridabarshe',
                'Kataijeli',
                'Katanga',
                'Katanka',
                'Katiu',
                'Kawga',
                'Kechebi',
                'Kedzi',
                'Kensere',
                'Kenyasi No 1',
                'Keta',
                'Kete Krache',
                'Kibi',
                'Kikam',
                'Kimabui',
                'Kintampo',
                'Kissi',
                'Klavw',
                'Klikor - Agbozume',
                'Kobresu',
                'Kodee',
                'Kofi Djan',
                'Kofiase',
                'Koforidua',
                'Kogota',
                'Kogyei',
                'Kokoben',
                'Kokofu',
                'Kokoso',
                'Kokuma',
                'Kologo',
                'Kololi',
                'Komampo',
                'Komenda',
                'Komonpa',
                'Konfogsi',
                'Kong',
                'Kongo',
                'Konkori',
                'Kononga',
                'Kopota',
                'Kotoko',
                'Kotu',
                'Kotua',
                'Koue',
                'Kpadui',
                'Kpagto',
                'Kpalbe',
                'Kpalbus',
                'Kpalguni',
                'Kpalisogu',
                'Kpandae',
                'Kpandu',
                'Kpanianba',
                'Kparekpare',
                'Kparigu',
                'Kpasa',
                'Kpasenk',
                'Kpatinga',
                'Kpedze',
                'Kpedzeglo',
                'Kpembe',
                'Kpetchu',
                'Kpetoe',
                'Kpeve',
                'Kpoglo',
                'Kpone',
                'Kpong',
                'Kpotsu',
                'Kptokuomtoas',
                'Kraboa Coaltar',
                'Krakurom',
                'Kroba',
                'Krobo',
                'Krokosue',
                'Krokrobite',
                'Ksauridabarshe',
                'Kubari',
                'Kudani',
                'Kugnani',
                'Kugnanidaboya',
                'Kugri Natinga',
                'Kuikpanga',
                'Kujopere',
                'Kukabila',
                'Kukuo',
                'Kukuom',
                'Kukurantumi',
                'Kulkpanga',
                'Kulmae',
                'Kulmasa',
                'Kulun',
                'Kulungugu',
                'Kulupene',
                'Kumasi',
                'Kumawu',
                'Kumbungu',
                'Kumfa',
                'Kunchoge Basirisan',
                'Kundang',
                'Kunkwa',
                'Kunso',
                'Kuntanse',
                'Kuntunso',
                'Kupullma',
                'Kusawgu',
                'Kusebi',
                'Kusinaba',
                'Kute',
                'Kutukrom',
                'Kwaben',
                'Kwabenadapaa',
                'Kwadwokurom',
                'Kwadwonkromkurom',
                'Kwahu Tafo',
                'Kwaihunu',
                'Kwakwanya',
                'Kwaman',
                'Kwame Danso',
                'Kwame Kwasi',
                'Kwamedwamenakurom',
                'Kwameseikurom',
                'Kwanyaku',
                'Kwawu',
                'Kwesiadai',
                'Kyekyewere',
                'Kyeraa',
                'Kyeremasu',
                'Kyinderi',
                'Labadi',
                'Labo',
                'Lambusie',
                'Lamin',
                'Lampel',
                'Lampurgo',
                'Langantre',
                'Langasi',
                'Langbinsi',
                'Lanja',
                'Larabanga',
                'Larekaga',
                'Larteh',
                'Laura',
                'Lawra',
                'Lepusi',
                'Lilikse Nankpawie',
                'Lobi',
                'Loggo',
                'Lolonya',
                'Longoro',
                'Lovi',
                'Luari',
                'Lungbunga',
                'Lungni',
                'Lziri',
                'Maasu',
                'Maknkuma',
                'Makongo',
                'Malume',
                'Mamfe',
                'Mampaten',
                'Mampon',
                'Mampong',
                'Mampoten',
                'Mandari',
                'Mankarigy',
                'Mankessim',
                'Mankpan',
                'Mankranso',
                'Mankuma',
                'Mankwadze',
                'Mansing',
                'Manso',
                'Manso Nkwanta',
                'Mantukwa',
                'Masaka',
                'Matse',
                'Mawuabammu',
                'Mengwe',
                'Mengyi',
                'Menusu',
                'Meriche',
                'Mim',
                'Mirigu-nabaanga',
                'Mishue',
                'Moglo',
                'Mogono',
                'Mojina',
                'Moree',
                'Moseaso',
                'Motigy',
                'Mpana',
                'Mpasaso',
                'Mpasem',
                'Mpataba',
                'Mpatoam',
                'Mpeam',
                'Mpohor',
                'Mpraeso',
                'Mrigu-nabara',
                'Mumford',
                'Muna',
                'Mungu',
                'Murugu',
                'Nabari',
                'Nabisi',
                'Nabogo',
                'Nabolo',
                'Nabori',
                'Nadiyili',
                'Nafkoliga',
                'Naga',
                'Naga Pwalugu',
                'Nagbo',
                'Nakong-atinia',
                'Nakpali',
                'Nakpayili',
                'Nakundugu',
                'Nakwa',
                'Nakwabi',
                'Nalerigu',
                'Namanso',
                'Namasua',
                'Nambiri',
                'Namvili',
                'Nandawli',
                'Nandom',
                'Nangodi',
                'Nangruma',
                'Nankanduri',
                'Nanton',
                'Naro',
                'Nasia',
                'Natinga',
                'Natog',
                'Nauli',
                'Navrongo',
                'Nawuni',
                'Nawuniyipala',
                'Nereso',
                'New Abirem',
                'New Debiso',
                'New Edubiase',
                'New Longoro',
                'New Ningo',
                'New Town',
                'New Worabon',
                'Nframa',
                'Nkasiem',
                'Nkawie',
                'Nkawkaw',
                'Nkenkasu',
                'Nketepa',
                'Nkoranza',
                'Nkroful',
                'Nkuntunso',
                'Nkwaben',
                'Nkwanta',
                'Nobekaw',
                'Nogokpo',
                'Npuasu',
                'Nsaba',
                'Nsawam',
                'Nsawkaw',
                'Nsinsin',
                'Nsuaem',
                'Nsuatre',
                'Nsuta',
                'Nteresa',
                'Ntereso',
                'Ntronan',
                'Nungua',
                'Nwereme',
                'Nyakrom',
                'Nyame Bekyere',
                'Nyamease',
                'Nyameyeadom',
                'Nyang',
                'Nyankpala',
                'Nyankumase',
                'Nyanyaano',
                'Nyensungi',
                'Nyinahin',
                'Nyive',
                'Nzema',
                'Obawale',
                'Obo',
                'Obogu',
                'Obomeng',
                'Obuase',
                'Obuasi',
                'Odahu',
                'Odami',
                'Odonkawkrom',
                'Odumase',
                'Odumasi',
                'Odumasua',
                'Oduponkpebe',
                'Ofaose',
                'Ofe',
                'Offinso',
                'Ofoase',
                'Oforikurom',
                'Ohiamankyene Kpetchu',
                'Ohyiayeanisa',
                'Ojobi',
                'Okomfookurom',
                'Old Edabo',
                'Old Ningo',
                'Oseekodwokurom',
                'Osenase',
                'Osino',
                'Osudoku',
                'Otekpolu',
                'Otrokpe',
                'Owusukuro',
                'Pabire',
                'Paga',
                'Palangasi',
                'Palari',
                'Pampawie',
                'Pankron',
                'Panyane',
                'Papase',
                'Patriensa',
                'Pawa',
                'Peblastre',
                'Pechi',
                'Peki',
                'Pelungo',
                'Pemenasi',
                'Perisi',
                'Pigu',
                'Pina',
                'Piong',
                'Pisie',
                'Pisigu',
                'Poano',
                'Poasi',
                'Pokoasi',
                'Polmakom',
                'Pomadze',
                'Pong-tamale',
                'Pramkese',
                'Prampram',
                'Prang',
                'Prestea',
                'Primase',
                "Prince's Town",
                'Pulo',
                'Pumpuni',
                'Pusiga',
                'Pusuga',
                'Pute',
                'Pwalugu',
                'Saani',
                'Sabari',
                'Saboba',
                'Sabonjida',
                'Sabuli',
                'Sabusa',
                'Sabzundi',
                'Sagadugu',
                'Sakai',
                'Sakala',
                'Sakode - Etae',
                'Sakomono',
                'Sakpa',
                'Salaga',
                'Salkpang',
                'Saltpond',
                'Samambow',
                'Samanhyia',
                'Sambo',
                'Sambreboe',
                'Sambrun',
                'Sambu',
                'Samila',
                'Samoa',
                'Sampa',
                'Sampemo',
                'Sampraso',
                'Sandema',
                'Sang',
                'Sangbaa',
                'Sankalaa',
                'Sankore',
                'Sankpala',
                'Sanujan',
                'Sanyang',
                'Sapiegu',
                'Saranouse',
                'Saripere',
                'Sarpere Ambo',
                'Sarri',
                'Saru',
                'Savelugu',
                'Sawla',
                'Seekwa',
                'Sefwi Anhwiaso',
                'Sefwi Bekwai',
                'Sefwi Wiawso',
                'Segbasi',
                'Sekasua',
                'Seketia',
                'Sekondi Takoradi',
                'Sekpe',
                'Sekyedumase',
                'Sekyerekurom',
                'Sema',
                'Senase',
                'Senchi',
                'Seneso',
                'Senfi',
                'Senkyiem',
                'Senya Bereku',
                'Seripe',
                'Serrekunda',
                'Sese',
                'Seseamam',
                'Shama',
                'Shi',
                'Shia',
                'Shiega',
                'Shieni',
                'Silibele',
                'Sinebaga',
                'Singa',
                'Siriminchu',
                'Sogakope',
                'Soma(mansakonko)',
                'Somanya',
                'Sombisi',
                'Soo',
                'Sovie',
                'Srogbae',
                'Subri',
                'Suggo',
                'Suhum',
                'Sukuta',
                'Sumiso',
                'Sumsei',
                'Sung',
                'Sunsan',
                'Sunyani',
                'Surukrom',
                'Swedru',
                'Taali',
                'Tachiman',
                'Tachimantia',
                'Tadieso',
                'Tadzevu',
                'Taenso',
                'Tahima',
                'Takoradi',
                'Takpo',
                'Tamale',
                'Tamale Port',
                'Tamaligu',
                'Tampion',
                'Tamso',
                'Tanaso',
                'Tangasia',
                'Tanina',
                'Tanji',
                'Tanoso',
                'Tantali',
                'Tarkwa',
                'Tarongo',
                'Tatale',
                'Teainano',
                'Techigu',
                'Teekyere',
                'Tefle',
                'Tema',
                'Tenfian',
                'Teselima',
                'Teshi',
                'Tetema',
                'Tetrem',
                'Tijo',
                'Tikobo No 1',
                'Tikobo No 2',
                'Tikpang',
                'Tilli',
                'Tinga',
                'Tolon',
                'Tongo',
                'Torsa',
                'Toyanyili',
                'Trede',
                'Trom',
                'Tromeso',
                'Tsito',
                'Tsrefe',
                'Tugu',
                'Tuluwe',
                'Tumfakura',
                'Tumu',
                'Tuna',
                'Tuobodom',
                'Turumi',
                'Tutukpene',
                'Tutumi',
                'Tuwuo',
                'Twenene',
                'Twifo Praso',
                'Twifo-mampon',
                'Ugando',
                'Vaggo',
                'Vakpo',
                'Vamboi',
                'Wa',
                'Waiasi',
                'Wakawaka',
                'Walembele',
                'Walewale',
                'Wam',
                'Wamanafo',
                'Wamfie',
                'Wangasi - Turu',
                'Waniada',
                'Wapuli',
                'Warinvaga',
                'Wasipe',
                'Waso',
                'Watoro',
                'Waya',
                'Wechiau',
                'Wegbe',
                'Weija',
                'Wenchi',
                'Wenchiki',
                'Wiaga-yisobso',
                'Wiamoase',
                'Wiasi',
                'Winisa',
                'Winkogo',
                'Winneba',
                'Wiosa',
                'Woe',
                'Worakese',
                'Worawora',
                'Wuinta',
                'Wulensi',
                'Wulensimpana',
                'Wumenu',
                'Wungu',
                'Wurnpigo',
                'Wuru',
                'Wute',
                'Yabraso',
                'Yabum',
                'Yagaba',
                'Yahaiyape',
                'Yakase',
                'Yala',
                'Yamatwa',
                'Yankoman',
                'Yankzia',
                'Yapei',
                'Yapessa',
                'Yawga',
                'Yazori',
                'Yendi',
                'Yepalsi',
                'Yezes',
                'Yikpabango',
                'Yipala',
                'Yundum',
                'Zabzugu',
                'Zanduli',
                'Zankum',
                'Zariboku',
                'Zebilla',
                'Zegbeli',
                'Zin',
                'Zion',
                'Zlope',
                'Zoggo',
                'Zoko',
                'Zongo-markyeri',
                'Zuarugu',
                'Zuro',
              ],
            },
          ],
        },
        {
          id: 'your-residential-address',
          type: 'list',
          readonly: false,
          label: 'Your Residential Address',
          uid: 'f18671c71db9f19a',
          content: [
            {
              id: 'life-assured-residential-address',
              type: 'list',
              readonly: false,
              label: 'Life Assured Residential Address',
              uid: '3e46c4738cbe9483',
              content: [
                {
                  id: 'street',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Street',
                  uid: '88b1cbe239f7d6d6',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'suburb',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Suburb',
                  uid: '6f690fbbc9d11723',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'your-digital-address',
          type: 'list',
          readonly: false,
          label: 'Your Digital Address',
          uid: 'b7a087458e852f01',
          content: [
            {
              id: 'life-assured-digital-address',
              type: 'list',
              readonly: false,
              label: 'Life Assured Digital Address',
              uid: '9a4167ebec4b20da',
              content: [
                {
                  id: 'digital-address',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Digital Address',
                  uid: '21e05158b0069035',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'your-employment-details',
          type: 'list',
          readonly: false,
          label: 'Your Employment Details',
          uid: '99b1729bd3e831a0',
          content: [
            {
              id: 'life-assured-employment-details',
              type: 'list',
              readonly: false,
              label: 'Life Assured Employment Details',
              uid: 'be86c61e4cd4426a',
              content: [
                {
                  id: 'employer-organisation',
                  type: 'field',
                  elementType: 'datalist',
                  readonly: false,
                  label: 'Employer Organisation',
                  uid: 'f748859c24fa4036',
                  content: '',
                  publishChange: true,
                  options: [],
                },
                {
                  id: 'employee-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Employee Number',
                  uid: 'b6ed993e9bc603ef',
                  content: '',
                  publishChange: true,
                  inputType: 'text',
                },
                {
                  id: 'occupation',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Occupation',
                  uid: '56d42f381a7802f1',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: [
                    '',
                    'Abattoir Worker',
                    'Accountant',
                    'Accounting Officer',
                    'Actor',
                    'Actress',
                    'Actuary',
                    'Admin Assistant',
                    'Administrator',
                    'Advertising Agent',
                    'Advocate',
                    'Affal Washer',
                    'Agriculture Assistant',
                    'Agriculture Officer',
                    'Air Force',
                    'Air Force Ground Crew',
                    'Aircraft Engineer',
                    'Airline Employee',
                    'Airline Executive',
                    'Airline Pilot',
                    'Ambulance Attendant',
                    'Ambulance Driver',
                    'Announcer',
                    'Artisan',
                    'Artist',
                    'Assessor',
                    'Auctioneer',
                    'Auditor',
                    'Author',
                    'Auto Electrician',
                    'Auxillary Worker',
                    'Aviation',
                    'Baker',
                    'Bank Teller',
                    'Bank-Manager',
                    'Banker',
                    'Bar Lady',
                    'Bar Steward',
                    'Barber',
                    'Barmaid',
                    'Barman',
                    'Beautician',
                    'Blacksmith',
                    'Blockman',
                    'Boilermaker',
                    'Bookbinder',
                    'Bookkeeper',
                    'Bookmaker',
                    'Boring Contractor',
                    'Bottle Store Assistant',
                    'Bottle Store Manager',
                    'Boxer',
                    'Bricklayer',
                    'Broker',
                    'Builder',
                    'Building Contractor',
                    'Building Foreman',
                    'Building Inspector',
                    'Bus Driver',
                    'Butcher',
                    'Buyer',
                    'Cabinetmaker',
                    'Cafe Owner',
                    'Cameraman',
                    'Cardiologist',
                    'Caretaker',
                    'Carpenter',
                    'Carpet Layer',
                    'Cashier',
                    'Caterer',
                    'Checker',
                    'Chef',
                    'Chief Officer',
                    'Chiropodist',
                    'Civil Defense Officer',
                    'Cleaner',
                    'Clergyman',
                    'Clerk',
                    'Cold Storage Worker',
                    'Commercial Photographer',
                    'Compositor-Electronic',
                    'Compositor-Mechanical',
                    'Computer Engineer',
                    'Computer Operator',
                    'Computer Programmer',
                    'Computer Systems Analyst',
                    'Computer Technician',
                    'Conductor',
                    'Constable',
                    'Construction Worker',
                    'Consultant',
                    'Cook',
                    'Copywriter',
                    'Councillor',
                    'Courier',
                    'Cropduster',
                    'Croupier',
                    'Customs Official',
                    'Dairy Worker',
                    'Dancing Teacher',
                    'Dean',
                    'Demolition Worker',
                    'Dental Assistant',
                    'Dental Technician',
                    'Dentist',
                    'Detective',
                    'Diamond Cutter',
                    'Dietician',
                    'Director',
                    'Display Artist',
                    'Diver',
                    'Dockworker',
                    'Doctor',
                    'Domestic',
                    'Draughtsman',
                    'Dressmaker',
                    'Driller',
                    'Driver',
                    'Dry Cleaner',
                    'Economist',
                    'Editor',
                    'Education Inspector',
                    'Educator',
                    'Electrical Contractor',
                    'Electrician',
                    'Electronics Engineer',
                    'Electroplater',
                    'Employee',
                    'Engineer',
                    'Engineer-Qualified',
                    'Engraver',
                    'Entomologist',
                    'Estate Agent',
                    'Executive',
                    'Explosives Worker',
                    'Exterminator',
                    'Farm Worker',
                    'Farmer Foreman',
                    'Farmer Manager',
                    'Farmer Owner',
                    'Fashion Designer',
                    'Film Maker',
                    'Fireman',
                    'Fisherman',
                    'Fitter And Turner',
                    'Floor Surfacer',
                    'Florist',
                    'Foreman',
                    'Forester',
                    'Fortune Teller',
                    'Foundry Manager',
                    'Foundry Worker',
                    'Freight Forwarder',
                    'Fumigator',
                    'Furnace Assistant',
                    'Furnace Manager',
                    'Furnace Supervisor',
                    'Game Ranger',
                    'Game Warden',
                    'Garage Attendant',
                    'Garage Owner',
                    'Gardener',
                    'General Assistant',
                    'General Dealer',
                    'General Worker',
                    'Geologist',
                    'Glassblower',
                    'Glazier',
                    'Goldsmith',
                    'Grain Silo Operator',
                    'Graphic Designer',
                    'Greengrocer',
                    'Groundsman',
                    'Guard (Security)',
                    'Gunsmith',
                    'Hairdresser',
                    'Hawker',
                    'Head Of Department',
                    'Headmaster',
                    'Health Inspector',
                    'Homeopath',
                    'Horticulturist',
                    'Hotel Manager',
                    'Housewife',
                    'Hr Assistant',
                    'Inspector',
                    'Insurance Agent',
                    'Insurance Assessor',
                    'Interior Decorator',
                    'Interpreter',
                    'Investigator',
                    'Jeweller',
                    'Jockey',
                    'Joiner',
                    'Journalist',
                    'Labourer',
                    'Lawyer',
                    'Lecturer',
                    'Librarian',
                    'Lift Inspector',
                    'Lift Operator',
                    'Lift Technician',
                    'Lighthouse Keeper',
                    'Locksmith',
                    'Machine Operator',
                    'Machinist',
                    'Magistrate',
                    'Major',
                    'Manager',
                    'Manicurist',
                    'Manufacturer',
                    'Market Researcher',
                    'Marketing Officer',
                    'Martial Arts Instructor',
                    'Mason',
                    'Meat Inspector',
                    'Mechanic',
                    'Medical Representative',
                    'Medical Technologist',
                    'Medical-Practitioner',
                    'Merchandiser',
                    'Merchant Seaman',
                    'Messenger',
                    'Metallurgist',
                    'Meter Reader',
                    'Midwife',
                    'Millwright',
                    'Miner',
                    'Minister Of Religion',
                    'Model',
                    'Motor Salesman',
                    'Motor Spares Salesman',
                    'Moulder',
                    'Musician',
                    'Naval Personnel',
                    'Night Watchman',
                    'Nurse',
                    'Nurseryman',
                    'Nursing Assistant',
                    'Nursing Sister',
                    'Occupational Therapist',
                    'Officer',
                    'Operator',
                    'Ophthalmologist',
                    'Optical Mechanic',
                    'Orthopedic Orthopedist',
                    'Packer',
                    'Painter',
                    'Painting Contractor',
                    'Panelbeater',
                    'Paramedic',
                    'Pastor',
                    'Pawnbroker',
                    'Pensioner',
                    'Permanent Way',
                    'Personnel Officer',
                    'Pest Exterminator',
                    'Petrol Attendant',
                    'Petroleum Refinery',
                    'Pharmacist',
                    'Photographer',
                    'Physiotherapist',
                    'Piano Tuner',
                    'Pilot',
                    'Plasterer',
                    'Plumber',
                    'Police Constable',
                    'Police Woman',
                    'Policeman',
                    'Porter',
                    'Postman',
                    'Postmaster',
                    'Principal',
                    'Printer',
                    'Prisons Personnel',
                    'Private Investigator',
                    'Producer',
                    'Professor',
                    'Programmer',
                    'Property Appraiser',
                    'Proprietor',
                    'Public Prosecutor',
                    'Public Relations Officer',
                    'Quality Controller',
                    'Quantity Surveyor',
                    'Quarryman',
                    'Racehorse Trainer',
                    'Radiographer',
                    'Radiologist',
                    'Receptionist',
                    'Religious Leader',
                    'Repairman',
                    'Representative',
                    'Research Assistant',
                    'Restaurant Owner',
                    'Retired',
                    'Rigger (Docks)',
                    'Roadworker',
                    'Sailor',
                    'Sales Consultant',
                    'Sales Lady',
                    'Sales Support',
                    'Sales Woman',
                    'Salesman',
                    'Seaman',
                    'Seaman (Merchant)',
                    'Seamstress',
                    'Secretary',
                    'Security Guard',
                    'Self-Employed',
                    'Sergeant',
                    'Shedman',
                    'Sheet Metal Worker',
                    'Shipping Agent',
                    'Shop Assistant',
                    'Shop Manager',
                    'Shopfitter',
                    'Shunter-Foreman',
                    'Signwriter',
                    'Silversmith',
                    'Singer',
                    'Slaughterer',
                    'Smelter',
                    'Social Worker',
                    'Soldier',
                    'Sound Engineer',
                    'Sportsman',
                    'Sportswoman',
                    'Spray Painter',
                    'Sprayer',
                    'Stationmaster',
                    'Statistician',
                    'Stevedore',
                    'Steward',
                    'Stock Broker',
                    'Store Lady',
                    'Storeman',
                    'Student',
                    'Supervisor',
                    'Surgeon',
                    'Sweeper',
                    'Swimming Pool Attendant',
                    'Switchboard Operator',
                    'Systems Analyst',
                    'Tailor',
                    'Taxi Driver',
                    'Teacher',
                    'Technician',
                    'Telegraphist',
                    'Telephone Technician',
                    'Telephonist',
                    'Tiler',
                    'Toolmaker',
                    'Town Clerk',
                    'Town Planner',
                    'Trader',
                    'Tradesman',
                    'Traffic Officer',
                    'Trainer',
                    'Translator',
                    'Travel Agent',
                    'Typesetter',
                    'Typist',
                    'Undertaker',
                    'Underwriter',
                    'Unemployed',
                    'Upholsterer',
                    'Urologist',
                    'Vetrinarian',
                    'Vetrinary Surgeon',
                    'Vulcaniser',
                    'Waiter',
                    'Waitress',
                    'Warden',
                    'Watch Maker',
                    'Watchman',
                    'Welder',
                    'Well Sinker',
                    'Window Cleaner',
                    'Window Dresser',
                    'Wood Cutter',
                    'Worker',
                    'Wrestler',
                  ],
                },
                {
                  id: 'basic-earnings',
                  type: 'amount',
                  elementType: 'input',
                  readonly: false,
                  label: 'Basic Earnings',
                  uid: '557bf270273a210d',
                  content: '',
                  publishChange: true,
                  inputType: 'number',
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'd56a07c519da3350',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'a856aa4d3af4472e',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '8928432143c5d39b',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '25157e1a71993bb8',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'abed9ed6fd97427b',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Policyholder Full Details',
    uri: 'transition/policyholder-full-details',
    template: 'transition-app-template',
    class: 'transition-policyholder-full-details',
  },
  'spouse-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'spouse-details',
      type: 'list',
      readonly: false,
      label: 'Spouse Details',
      uid: '87e61a1740b1a950',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '2a669ec2b7c2d500',
          content: '<h2>Spouse Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'c511e369f46cba38',
          content:
            '<p>Please give us the details of the other lives you want to add to your plan</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'e55ea46b1a371db4',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'spouse-details',
          type: 'list',
          readonly: false,
          label: 'Spouse Details',
          uid: '15bc7523284687ba',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '212bf9ff886dd6c1',
              content: '<p>Please complete the details of your spouse</p>\n',
            },
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: '0bd7a4384c87e728',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: 'b7608ba102fb6c2b',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: '179e4de315a3d147',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'date',
              component: 'DateSelector',
              maxYear: 2021,
            },
            {
              id: 'idpassport-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'ID/Passport Number',
              uid: '1f6fd287652f51b4',
              content: '',
              publishChange: true,
              inputType: 'text',
            },
            {
              id: 'spouse-id-type-radio-group',
              type: 'list',
              readonly: false,
              label: 'Spouse ID Type Radio Group',
              uid: 'ed15d233eee42ceb',
              content: [
                {
                  id: 'dvla',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Dvla',
                  uid: '412900b12db617fd',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'passport',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Passport',
                  uid: '1254e3cfc0785626',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'voter-id',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Voter ID',
                  uid: '41b0c8be19904033',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'nhis',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Nhis',
                  uid: 'e023ba047d31c7f1',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'ssnit',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Ssnit',
                  uid: '26849c388eb02127',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'nia-ghana-card',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Nia Ghana Card',
                  uid: 'c017d3973aa1d6b6',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
            {
              id: 'gender',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Gender',
              uid: '85b49ea36093b4ee',
              content: '',
              inputType: 'text',
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: 'ce4d1bfdca8a31fd',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: 'c89a6d591f6c88da',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '5770019bd0d0f658',
              content:
                '<p>Specify your spouse to be the trustee of the plan</p>\n',
            },
            {
              id: 'spouse-is-trustee',
              type: 'field',
              elementType: 'checkbox',
              readonly: false,
              label: 'Spouse Is Trustee',
              uid: '808941df10d21b7f',
              content: '',
              publishChange: true,
              options: ['Y', 'N'],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'bd76c2d18c7f5264',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'c6d86a26cc2b9c33',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '9bf9c4038f2bb849',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'd8d79789309b91c7',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'a0a51d7b3dc255ae',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Spouse Details',
    uri: 'transition/spouse-details',
    template: 'transition-app-template',
    class: 'transition-spouse-details',
  },
  'trustee-details': {
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'trustee-details',
      type: 'list',
      readonly: false,
      label: 'Trustee Details',
      uid: '06cc0283aae01812',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '716305c544aa14a7',
          content: '<h2>Trustee Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53952a550bf734cc',
          content: '',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '8ac4d130f3be0edd',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'trustee-identification',
          type: 'list',
          readonly: false,
          label: 'Trustee Identification',
          uid: 'ea77dd28ca9b6cb4',
          content: [
            {
              id: 'first-names',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'First Names',
              uid: '66d1c959d5ff80fb',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'surname',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Surname',
              uid: '939805a03a59ba9a',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
            {
              id: 'date-of-birth',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Date Of Birth',
              uid: '8c3344fe2f04f1c2',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'date',
              component: 'DateSelector',
              maxYear: thisYear,
            },
            {
              id: 'cell-phone',
              type: 'component',
              elementType: 'input',
              readonly: false,
              label: 'Cell Phone',
              uid: 'b5fe4f0fda749fc3',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'tel',
              component: 'PhoneNumber',
            },
            {
              id: 'relationship',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Relationship',
              uid: '14b853cd260d36ae',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Brother',
                'Daughter',
                'Estate',
                'Father',
                'Father-In-Law',
                'Grandfather',
                'Grandmother',
                'Mother',
                'Mother-In-Law',
                'Sister',
                'Son',
                'Spouse',
                'Testament',
                'Trust',
              ],
            },
            {
              id: 'title',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Title',
              uid: '10e4727a0b4bd062',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Adv',
                'Dr',
                'Miss',
                'Mr',
                'Mrs',
                'Ms',
                'Prof',
                'Rev',
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: '105de1a483e8f56e',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '7f9ae4e23548bcdd',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '844a9e2aa0c1a85e',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: 'cfbd45d5eff5add0',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'c915d127733ac59f',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Trustee Details',
    uri: 'transition/trustee-details',
    template: 'transition-app-template',
    class: 'transition-trustee-details',
  },
  'additional-lives': {
    text: [],
    buttons: [
      {
        label: 'Recalculate',
        id: 'recalculate',
        uid: 'f7e7fcc76ead3671',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'additional-lives',
      type: 'list',
      readonly: false,
      label: 'Additional Lives',
      uid: 'b5ab45afecfcc13f',
      content: [],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'Transition Plan Lives Assured',
    uri: 'transition-plan/lives-assured',
    template: 'transition-lives-assured-screen',
    class: 'transition-plan-lives-assured',
  },
  'payment-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: '6addaf7c36a8a368',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'payment-method',
          type: 'list',
          readonly: false,
          label: 'Payment Method',
          uid: '935b4319fdcbab12',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'b3820d390c57590c',
              content: '<p>Choose a payment method</p>\n',
            },
            {
              id: 'payment-method-radio-group',
              type: 'list',
              readonly: false,
              label: 'Payment Method Radio Group',
              uid: '5f29ef713684dcdd',
              content: [
                {
                  id: 'debit-order',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Debit Order',
                  uid: '66026bce0175bd85',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
                {
                  id: 'stop-order',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Stop Order',
                  uid: 'addc4bc1f4c832eb',
                  content: '',
                  publishChange: true,
                  options: ['Y'],
                },
              ],
              errors: ['*'],
            },
          ],
        },
        {
          id: 'payment-commencement',
          type: 'list',
          readonly: false,
          label: 'Payment Commencement',
          uid: 'de98afcf136dd1ea',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'a50540585ca12c07',
              content:
                '<p>Choose the payment start date and your payment frequency</p>\n',
            },
            {
              id: 'payment-start-date',
              type: 'integer',
              elementType: 'select',
              readonly: false,
              label: 'Payment Start Date',
              uid: 'cd4537bfa3fb5f7d',
              content: '20210701',
              publishChange: true,
              options: ['', '20210701', '20210801', '20210901'],
            },
            {
              id: 'payment-frequency',
              type: 'list',
              readonly: true,
              label: 'Payment Frequency',
              uid: 'a4378d59523b930d',
              content: [
                {
                  id: 'payment-frequency',
                  type: 'list',
                  readonly: true,
                  label: 'Payment Frequency',
                  uid: '6ffa3a611ed9e88d',
                  content: [
                    {
                      id: 'monthly',
                      type: 'field',
                      elementType: 'input',
                      readonly: true,
                      label: 'Monthly',
                      uid: '4577e5da0a3891cf',
                      content: 'Y',
                      inputType: 'text',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 'payer-person',
          type: 'list',
          readonly: false,
          label: 'Payer Person',
          uid: 'ce35234c9c489acc',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: 'ee7c49bb35030b57',
              content: '<p>Who will be paying for this policy?</p>\n',
            },
            {
              id: 'payer-person-radio-group',
              type: 'list',
              readonly: false,
              label: 'Payer Person Radio Group',
              uid: '2c1019491493ebab',
              content: [
                {
                  id: 'myself',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'Myself',
                  uid: '4d7d4200a4fd7585',
                  content: 'Y',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
                {
                  id: 'my-spouse',
                  type: 'field',
                  elementType: 'checkbox',
                  readonly: false,
                  label: 'My Spouse',
                  uid: '6198ae13e0925e88',
                  content: '',
                  publishChange: true,
                  options: ['Y', 'N'],
                },
              ],
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'da2747370907b8ad',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '5a201a928736f085',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd768749ed81c8eec',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '2aea10aeb7915580',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: '8588b418b3adff34',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Payment Details',
    uri: 'transition/quote',
    template: 'transition-app-template',
    class: 'transition-payment-details',
  },
  'debit-order-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: '69b75af77b1bdd00',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'debit-order-details',
          type: 'list',
          readonly: false,
          label: 'Debit Order Details',
          uid: '22fcc19d1d51c088',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '82bc4d510e05f52c',
              content: '<p>Complete the following details</p>\n',
            },
            {
              id: 'new-account-details',
              type: 'list',
              readonly: false,
              label: 'New Account Details',
              uid: 'd6c40fa02c7a5432',
              content: [
                {
                  id: 'account-holder-name',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Account Holder Name',
                  uid: '9c6feae6444b8807',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
                {
                  id: 'account-type',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Type',
                  uid: 'fbdc797b84a0f751',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: ['', 'Current', 'Savings'],
                },
                {
                  id: 'account-entity-name',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Account Entity Name',
                  uid: '41ac2dfe1beb4c8d',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  options: [
                    '',
                    'Absa (gh) Ltd',
                    'Access Bank Ghana Ltd',
                    'Agricultural Development Bank',
                    'Bank Of Africa',
                    'Cal Bank Ltd',
                    'Consolidated Bank Ghana',
                    'Ecobank Ghana Ltd',
                    'Fidelity Bank Ghana',
                    'First Atlantic Bank Ltd',
                    'First Bank Nigeria',
                    'Gcb Bank Ltd',
                    'Guaranty Trust (gh) Ltd',
                    'National Investment Bank',
                    'Omni Bank Ghana Ltd',
                    'Prudential Bank Ltd',
                    'Republic Bank (gh) Ltd',
                    'Societe General Ghana Ltd',
                    'Stanbic Bank Ghana Ltd',
                    'Standard Chartered Bank',
                    'United Bank For Africa (gh) Ltd',
                    'Universal Merchant Bank (gh) Ltd',
                    'Zenith Bank',
                  ],
                },
                {
                  content: '',
                  elementType: 'select',
                  errors: ['*'],
                  id: 'account-branch-name',
                  label: 'Account Branch Name',
                  options: [
                    '',
                    '1ST LIGHT',
                    '31ST DECEMBER MARKET',
                    'A & C MALL',
                    'A & C SHOPPING MAIL',
                    'A AND C',
                    'A AND C MALL',
                    'A COMMUNITY BANK LTD-LA',
                    'A RURAL BANK LTD-AMASAMAN',
                    'A&C MALL',
                    'AA ASANTEWAA RURAL BANK LTD',
                    'AARA RURAL BANK LTD-PAGA',
                    'AASEMAN RURAL BANK LTD-KAASE',
                    'ABBOSEY OKAI',
                    'ABBOSEY OKAI BRANCH',
                    'ABEKA',
                    'ABEKA BRANCH',
                    'ABEKA LAPAZ',
                    'ABEKA LAPAZ BRANCH',
                    'ABEKALAPAZ',
                    'ABELENKPE',
                    'ABETIFI',
                    'ABETIFI BRANCH',
                    'ABII NATIONAL SAVINGS AND LOANS LTD',
                    'ABN-50129-TEMA COMMUNITY 9',
                    'ABOABO',
                    'ABOABO MARKET TAMALE',
                    'ABOKOBI RURAL BANK LTD-ABOKOBI',
                    'ABOR',
                    'ABORA',
                    'ABOSEY OKAI',
                    'ABOSSEY OKAI',
                    'ABOSSEY OKINE',
                    'ABREPO JUNCTION',
                    'ABREPO JUNCTION BRANCH',
                    'ABREPO MAIN',
                    'ABREPO MAIN BRANCH',
                    'ABUAKWA',
                    'ABUAKWA BRANCH',
                    'ABURA DUNKWA',
                    'ABURI',
                    'ABZUGU RURAL BANK LTD',
                    'ACCCRA NEWTOWN',
                    'ACCION',
                    'ACCRA',
                    'ACCRA & MAKOLA',
                    'ACCRA BRANCH',
                    'ACCRA CENTRAL',
                    'ACCRA CENTRAL POST',
                    'ACCRA CENTRAL POSTBANK',
                    'ACCRA CORPORATE SERVICE CENTRE',
                    'ACCRA MAIN',
                    'ACCRA MALL',
                    'ACCRA NEW TOWN',
                    'ACCRA SHOPPING MAIL',
                    'ACCRA SHOPPING MALL',
                    'ACHIASE',
                    'ACHIMOTA',
                    'ACHIMOTA BRANCH',
                    'ACHIMOTA MILE 7',
                    'ACTION CHAPEL',
                    'ADA FOAH',
                    'ADA RURAL BANK LTD-KASSEH',
                    'ADABOKROM',
                    'ADABRAKA',
                    'ADABRAKA BRANCH',
                    'ADANSI RURAL BANK LTD-FOMENA',
                    'ADAWSO',
                    'ADB HOUSE',
                    'ADB HOUSE BRANCH',
                    'ADEHYEMAN SAVINGS & LOAN',
                    'ADEHYEMAN SAVINGS AND LOANS',
                    'ADENTA',
                    'ADENTA BRANCH',
                    'ADENTA MARKET',
                    'ADENTAN',
                    'ADI HARBOUR',
                    'ADIAKIO WAYA',
                    'ADIDOME',
                    'ADJABENG',
                    'ADJIRINGANOR',
                    'ADONTEN COMMUNITY BANK LTD-NEW TAFO',
                    'ADUM',
                    'ADUM BRANCH',
                    'ADUM POST',
                    'ADUMAN RURAL BANK LTD-BADU',
                    'ADUM-KUMASI',
                    'AFANA RURAL BANK LTD-SAMPA',
                    'AFFUL NKWANTA',
                    'AFFUL NKWANTA BRANCH',
                    'AFLAO',
                    'AFRAM RURAL BANK LTD-TEASE',
                    'AFRANSIE',
                    'AGAVE RURAL BANK LTD-DABALE',
                    'AGBOBLOSHIE',
                    'AGBOGBLOSHIE',
                    'AGBOGBOLSHIE',
                    'AGBOZUME',
                    'AGOGO',
                    'AGONA ABREM',
                    'AGONA AHANTA',
                    'AGONA ASHANTI',
                    'AGONA NKWANTA',
                    'AGONA RURAL BANK LTD-KWANYAKU',
                    'AGONA SWEDRU',
                    'AHAFO ANO PREMIER RURAL BANK LTD-WIOSO',
                    'AHAFO COMMUNITY RURAL BANK LTD-KUKUOM',
                    'AHANTAMAN RURAL BANK LTD-AGONA NKWANTA',
                    'AHINSAN KUMASI',
                    'AHODWO',
                    'AHODWO BRANCH',
                    'AIRPORT',
                    'AIRPORT BRANCH',
                    'AIRPORT CITY',
                    'AIRPORT CITY BRANCH',
                    'AIRPORT EAST',
                    'AIYINASE',
                    'AJUMAKO',
                    'AKASTI',
                    'AKATAKYIMAN RURAL BANK LTD-KOMENDA',
                    'AKATSI',
                    'AKIM ABENASE',
                    'AKIM ADUASA',
                    'AKIM BOSOME RURAL BANK LTD-AKIM SWEDRU',
                    'AKIM ODA',
                    'AKIM SWEDRU',
                    'AKOFO HOUSE',
                    'AKONTOMBRA',
                    'AKOSOMBO',
                    'AKOSOMBO BRANCH',
                    'AKOTI RURAL BANK LTD-ASSIN AKROPONG',
                    'AKROFUOM AREA RURAL BANK LTD-AKROFUOM',
                    'AKROPONG',
                    'AKROPONG AKWAPIM',
                    'AKROSO',
                    'AKUAPEM RURAL BANK LTD-MAMFE',
                    'AKUM RURAL BANK LTD-ELMINA',
                    'AKUMADAN',
                    'AKUSE',
                    'AKWADUM',
                    'AKWATIA',
                    'AKWETEYMAN',
                    'AKYEM MANSA RURAL BANK LTD-AYIREBI',
                    'AKYEPIM RURAL BANK LTD-GOMOA-DAW',
                    'ALABAR',
                    'ALABAR BRANCH',
                    'ALPHA CAPITAL SAVING&L LTD',
                    'AMAKOM',
                    'AMAKOM BRANCH',
                    'AMANANO RURAL BANK LTD-NYINAHIM',
                    'AMANTEN',
                    'AMASAMAN',
                    'AMASIE WEST RURAL BANK LTD-ANTOAKROM',
                    'AMATIN AND KASEI COMMUNITY BANK LTD-KASEI',
                    'AMENFIMAN RURAL BANK LTD-WASSA AKROPONG',
                    'AMERICAN HOUSE BRANCH',
                    'AMFIE RURAL BANK LTD-WAMFIE',
                    'ANDOM RURAL BANK LTD-NANDOM',
                    'ANGBE RURAL BANK LTD-PRAMPRAM',
                    'ANKOBRA WEST (ESIAMA) RURAL BANK LTD-ESIAMA',
                    'ANLO RURAL BANK LTD-ANLOGA',
                    'ANLOGA',
                    'ANSOMAN RURAL BANK LTD-MANSO-AMENFI',
                    'ANTEAKWA RURAL BANK LTD-KOFORIDUA',
                    'ANUM APAPAM',
                    'ANUM RURAL BANK LTD-ANUM',
                    'ANYA KROBO RURAL BANK LTD-ODUMASE-KROBO',
                    'ANYAA',
                    'ANYAA MARKET BRANCH',
                    'ANYINAM',
                    'APAM',
                    'APENKWA',
                    'APENKWA BRANCH',
                    'APEX BANK - BOLGA CENTRE-BOLGATANGA',
                    'APEX BANK - CAPE COASTCAPE COAST',
                    'APEX BANK - TAMALE CENTRE-TAMALE',
                    'APEX BANK -HEAD OFFICE-SOUTH RIDGE ACCRA',
                    'APEX BANK -HOHOE CENTRE-HOHOE',
                    'APEX BANK KOFORIDUA CENTRE-KOFORIDUA',
                    'APEX BANK -SUNYANI CENTRE-SUNYANI',
                    'APEX BANK -WA CENTRE-WA',
                    'APEX BANKACCRA CENTRE-ACCRA',
                    'APEX BANK-HO CENTRE-HO',
                    'APEX BANK-KUMASIKUMASI',
                    'APEX BANK-TAKORADI CENTRE-TAKORADI',
                    'APEX LINK CENTRE-CEDI HOUSE',
                    'APITAL RURAL BANK LTD-ABESIM',
                    'APLAKU',
                    'APRA RURAL BANK LTD-PRANG',
                    'ARENA BRANCH',
                    'ASAFO',
                    'ASAFO BRANCH',
                    'ASAFO MARKET',
                    'ASAMANKESE',
                    'ASANKRAGUA',
                    'ASANKRAGWA',
                    'ASANTE AKYEM RURAL BANK LTD-JUANSA',
                    'ASAWINSO BRANCH',
                    'ASAWINSO RURAL BANK LTD-SEFWI-ASAWINSO',
                    'ASEBU',
                    'ASEMKROM',
                    'ASEMPANEYE',
                    'ASH TOWN',
                    'ASHAIMAN',
                    'ASHAIMAN BRANCH',
                    'ASHAIMAN LEBABNON',
                    'ASHAIMAN MAIN BRANCH',
                    'ASHAIMAN ROUND ABOUT BRANCH',
                    'ASHALLEY BOTWE BRANCH',
                    'ASHANTI BEKWAI',
                    'ASHANTI MAMPONG',
                    'ASHIAMAN',
                    'ASHIYEA BRANCH',
                    'ASHTOWN',
                    'ASHTOWN BRANCH',
                    'ASHTOWN EAST',
                    'ASHTOWN EAST BRANCH',
                    'ASIAKWA',
                    'ASIKUMA',
                    'ASOKORE RURAL BANK LTD-ASOKRE',
                    'ASOKWA',
                    'ASOKWA BRANCH',
                    'ASSIN FOSO',
                    'ASSIN FOSU',
                    'ASSIN FOSU POST',
                    'ASSINMAN RURAL BANK LTD-ASSIN MANSO',
                    'AST MANPRUSI COMMUNITY BABK LTD-GAMBAGA',
                    'ASTERN GOMOA ASSIN RURAL BANK LTD-GOMOA-DOMINASE',
                    'ASUBONTEN RURAL BANK LTD-WORAWORA',
                    'ASUOGYAMAN RURAL BANK LTD-ACCRA',
                    'ASUOPRA RURAL BANK LTD-AFOSU',
                    'ASUTIFI RURAL BANK LTD-ACERENSUA',
                    'ASUTUARE',
                    'ASYLUM DOWN',
                    'ATAABADZE',
                    'ATEBUBU',
                    'ATIWA RURAL BANK',
                    'ATIWA RURAL BANK LTD-KWABENG',
                    'ATOMIC BRANCH',
                    'ATOMIC JUNCTION BRANCH',
                    'ATONSU',
                    'ATONSU BRANCH',
                    'ATWEABAN RURAL BANK LTD-SUNYANI',
                    'ATWIMA KWANWOMA RURAL BANK LTD-PAKYI NO. 2',
                    'ATWIMA MPONUA RURAL BANK LTD-TOASE',
                    'ATWIMA RURAL BANK LTD-FOASE',
                    'AVENOR RURAL BANK LTD-AKATSI',
                    'AVENUE CENTRAL',
                    'AWASO',
                    'AWJIASE AREA RURAL BANK LTD-AWUTU BAWJIASE',
                    'AWRA RURAL BANK LTD-WA',
                    'AWUTU',
                    'AWUTU EMASA RURAL BANK LTD-AWUMASA',
                    'AXIM',
                    'AXIM ROAD BRANCH',
                    'AYANFURI',
                    'AYETEPA',
                    'AYIREBI',
                    'AYOMSO',
                    'BAATSONA',
                    'BAATSONA BRANCH',
                    'BADUKROM',
                    'BADUMAN RURAL BANK LTD-BADU',
                    'BAMAHU',
                    'BANDA NKWANTA',
                    'BANTAMA',
                    'BANTAMA 1',
                    'BANTAMA BRANCH',
                    'BANTAMA GNTC BRANCH',
                    'BASYONDE',
                    'BATSONA BRANCH',
                    'BAWALESHIE',
                    'BAWDJIASE',
                    'BAWJIASE AREA RURAL BANK LTD-AWUTU BAWJIASE',
                    'BAWKU',
                    'BAWKU BRANCH',
                    'BCM',
                    'BECHEM',
                    'BEGORO',
                    'BEIGE CAPITAL',
                    'BEKWAI',
                    'BEPOSO',
                    'BEREKUM',
                    'BESEASE',
                    'BESSFA RURAL BANK LTD-GARU',
                    'BESTPOINT SAVINGS AND LOANS',
                    'BEYIN',
                    'BI RURAL BANK LTD-HOHOE',
                    'BIA DEBISO',
                    'BIA-TORYA RURAL BANK LTD-BONSU-NKWANTA',
                    'BIBIANI',
                    'BIMBILLA',
                    'BINABA',
                    'BIRIWA',
                    'BOGOSO',
                    'BOGOSU',
                    'BOINSO',
                    'BOKOBI RURAL BANK LTD-ABOKOBI',
                    'BOLE',
                    'BOLE BRANCH',
                    'BOLGA COMMERCIAL ROAD BRANCH',
                    'BOLGA POLICE STATION ROAD BRANCH',
                    'BOLGA POST',
                    'BOLGA POSTBANK',
                    'BOLGATANGA',
                    'BOMAA AREA RURAL BANK LTD-BOMAA',
                    'BOMOSADU RURAL BANK LTD',
                    'BOND SAVINGS AND LOANS',
                    'BONGO',
                    'BONGO RURAL BANK LTD-BOLGATANGA',
                    'BONSO NKWANTA',
                    'BONSU NKWANTA',
                    'BONTRASE',
                    'BONZALI RURAL BANK LTD-KUMBUNGU',
                    'BORIMANGA RURAL BANK LTD-SAVELEGU',
                    'BOSOME FREHO RURAL BANK LTD-KUMASI',
                    'BOSOMTWI RURAL BANK LTD-KUNTANASE',
                    'BOUNDARY ROAD',
                    'BRAKWA BRAMAN RURAL BANK LTD-BRAKWA',
                    'BREEZE EAST LEGON',
                    'BREMAN ASIKUMA',
                    'BREMAN UGC',
                    'BUI',
                    'BUILSA COMMUNITY BANK LTD-SANDEMA',
                    'BUIPE',
                    'BUNKPRUGU',
                    'BURMA CAMP',
                    'BURMA CAMP BRANCH',
                    'BUSIE',
                    'BUSUNYA',
                    'BUTAWU RURAL BANK LTD-HO',
                    'BUWUULONSO RURAL BANK LTD-TAMALE',
                    'CAPE COAST',
                    'CAPE COAST BRANCH',
                    'CAPE COAST- MELCOM',
                    'CAPE COAST- MFANTSIPIM',
                    'CAPECOAST BRANCH',
                    'CAPITAL RURAL BANK LTD-ABESIM',
                    'CASTLE RD',
                    'CASTLE ROAD',
                    'CASTLE ROAD (HEAD OFFICE)',
                    'CASTLE ROAD BRANCH',
                    'CEDI HOUSE',
                    'CHAMBA',
                    'CHAPEL SQUARE',
                    'CHARIA',
                    'CHEREPONI',
                    'CHIRAA',
                    'CHORKOR',
                    'CIRCLE',
                    'CIRCLE BRANCH',
                    'CITIZEN RURAL BANK LTD-ACCRA',
                    'CLEARING UNIT',
                    'COLLINS AVENUE',
                    'COLLINS STREET',
                    'COMMUNITY 25',
                    'COMMUNITY 6',
                    'COMMUNITY1 BRANCH',
                    'CONSUMER FINANCE COMPANY (CFC) LTD',
                    'CORPORATE',
                    'CORPORATE SERVICE CENTRE',
                    'CUC MIOTSO',
                    'DA RURAL BANK LTD-KASSEH',
                    'DABALA',
                    'DABAN',
                    'DABOASE',
                    'DADIESO',
                    'DAMANG',
                    'DAMANGO',
                    'DAMBAI',
                    'DAMONGO',
                    'DANGBE RURAL BANK LTD-PRAMPRAM',
                    'DANICOM HOUSE(KOKOMLEMLE)',
                    'DANQUAH CIRCLE',
                    'DANSI RURAL BANK LTD-FOMENA',
                    'DANSOMAN',
                    'DANSOMAN EXHIBITION BRANCH',
                    'DANSOMAN ROUND-ABOUT BRANCH',
                    'DARKUMAN',
                    'DARKUMAN BRANCH',
                    'DAWA',
                    'DENKYIRAMAN RURAL BANK LTD-AYAMFURI',
                    'DENU',
                    'DERBY AVENUE',
                    'DERMA',
                    'DERMA RURAL BANK LTD-DERMA',
                    'DIRECT SALES',
                    'DODOWA',
                    'DOME',
                    'DOME BRANCH',
                    'DOME ST. JOHNS',
                    'DONKORKROM',
                    'DONTEN COMMUNITY BANK LTD-NEW TAFO',
                    'DORMAA AHENKRO',
                    'DOTOBRI RURAL BANK LTD-JACOBU',
                    'DROBO',
                    'DROBO COMMUNITY RURAL BANK LTD-DROBO',
                    'DRORWULU',
                    'DUADASO',
                    'DUAYAW NKANTA',
                    'DUAYAW NKWANTA',
                    'DUMPONG RURAL BANK LTD-OFRAMASE',
                    'DUNKWA',
                    'DUNKWA OFFIN',
                    'DUNKWA ON-OFFIN',
                    'DUNKWA-ON-OFFIN',
                    'DUNKWAW-ON-OFFIN BRANCH',
                    'DUPONGKPEHE RURAL BANK LTD-KASOA',
                    'DWEN-ANOMA RURAL BANK LTD-KWEEHWEE',
                    'DWORWULU WEST AIRPORT',
                    'DZEMENI',
                    'DZODZE',
                    'DZORWULU',
                    'DZORWULU BRANCH',
                    'DZORWULU MOTORWAY',
                    'DZWORWULU',
                    'EAST AIRPORT BRANCH',
                    'EAST CANTONMENT',
                    'EAST CANTONMENTS BRANCH',
                    'EAST LEGON',
                    'EAST LEGON 1',
                    'EAST LEGON 2',
                    'EAST LEGON BRANCH',
                    'EAST MANPRUSI COMMUNITY BABK LTD-GAMBAGA',
                    'EASTERN GOMOA ASSIN RURAL BANK LTD-GOMOA-DOMINASE',
                    'EBANKESE',
                    'ECOBANK BANTAMA GNTC',
                    'ECOBANK COMMUNITY 1',
                    'ECOBANK E PROCESS',
                    'ECOBANK EAST AIRPORT',
                    'ECOBANK EVANDY HOSTEL',
                    'ECOBANK GH TAMALE',
                    'ECOBANK GHANA',
                    'ECOBANK HIGH STREET',
                    'ECOBANK HOSPITAL ROAD',
                    'ECOBANK KANTAMANTO',
                    'ECOBANK MADINA CENTRAL',
                    'ECOBANK OKPONGLO',
                    'ECOBANK PENTAGON LEGON',
                    'ECOBANK SSNIT HOUSE',
                    'ECOBANK SUAME',
                    'EFFIDUASE',
                    'EFWIMAN RURAL BANK LTD-SEFWI-ASAW',
                    'EJISU',
                    'EJISU BRANCH',
                    'EJURA',
                    'EJURAMAN RURAL BANK LTD-KUMASI',
                    'EKUMFIMAN RURAL BANK LTD-ESSUEHYIA',
                    'EKYEDUMASI RURAL BANK LTD-SEKYEDUMASI',
                    'EKYERE RURAL BANK LTD-JAMASI',
                    'ELMINA',
                    'ELMINA - CHAPEL SQUARE',
                    'ELMINA -ESSUAKYIR',
                    'ELUBO',
                    'ELUBU',
                    'ENCHI',
                    'ENCHI BRANCH',
                    'ENCHI RURAL BANK LTD',
                    'ENKYIRAMAN RURAL BANK LTD-AYAMFURI',
                    'ENYAN DENKYIRA RURAL BANK LTD-ENYAN DENKYIRA',
                    'EPAMAN RURAL BANK LTD - TEPAMAN',
                    'EPE AREA RURAL BANK LTD-MEPE',
                    'ERMA RURAL BANK LTD-DERMA',
                    'ESIAMA',
                    'ESSAM',
                    'ESSFA RURAL BANK LTD-GARU',
                    'EST MANPRUSI COMMUNITY BANK LTD-WALEWALE',
                    'ESTERN RURAL BANK LTD-WASSA AKROPONG',
                    'ETO RURAL BANK LTD-KPEVE',
                    'EVANDY HOSTEL BRANCH',
                    'EZI SAVINGS AND LOANS LTD',
                    'FAANOFA',
                    'FAMAL',
                    'FANTEAKWA RURAL BANK LTD-KOFORIDUA',
                    'FANTSIMAN COMMUNITY RURAL BANK LTD-BIRIWA',
                    'FARRAR',
                    'FFINSO RURAL BANK LTD-KUMASI',
                    'FIAGYA RURAL BANK LTD-BUSUNYA',
                    'FIAPRE',
                    'FIASEMAN (BOGOSO AREA) RURAL BANK LTD-BOGOSO',
                    'FIRST AFRICAN SAVINGS AND LOANS',
                    'FIRST ALLIED SAVINGS & LOANS',
                    'FIRST ALLIED SAVINGS AND LOANS',
                    'FIRST GHANA BUILDING SOCIETY- ACCRA',
                    'FIRST GHANA BUILDING SOCIETY- KOFORIDUA',
                    'FIRST GHANA BUILDING SOCIETY- KUMASI AMAKOM',
                    'FIRST GHANA BUILDING SOCIETY- KUMASI SUAME',
                    'FIRST GHANA BUILDING SOCIETY- SUNYANI',
                    'FIRST GHANA BUILDING SOCIETY- TAKORADI',
                    'FIRST GHANA BUILDING SOCIETY-HEAD OFFICE',
                    'FIRST GHANA BUILDING SOCIETY-HOHOE',
                    'FIRST GHANA BUILDING SOCIETY-TAKORADI',
                    'FIRST GHANA BUILDING SOCIETY-TEMA',
                    'FIRST NATATIONAL S&L',
                    'FIRST NATIONAL SAVINGS & LOANS',
                    'FOASE',
                    'FOREIGN',
                    'FOREIGN OPERATIONS',
                    'FOREIGN OPERATIONS BRANCH',
                    'FRAM RURAL BANK LTD-TEASE',
                    'FULFOSO',
                    'FUMBISI',
                    'GA RURAL BANK LTD-AMASAMAN',
                    'GAMASHIE',
                    'GARU',
                    'GAVE RURAL BANK LTD-DABALE',
                    'GBI RURAL BANK LTD-HOHOE',
                    'GICEL',
                    'GIMPA',
                    'GIMPA BRANCH',
                    'GLOBAL ACCESS SAVINGS & LOANS CO. LTD',
                    'GNPC',
                    'GNPC TEMA',
                    'GOASO',
                    'GOLDEN TULIP KUMASI BRANCH',
                    'GOLOKWATI',
                    'GOMOA AJUMAKO RURAL BANK LTD-AFRANSI',
                    'GOMOA RURAL BANK LTD-APAM',
                    'GONA RURAL BANK LTD-KWANYAKU',
                    'GRAPHIC ROAD',
                    'GREL',
                    'GULF HOUSE',
                    'GUMANI',
                    'GUSHIEGU',
                    'GWB LAPAZ',
                    'HAATSO',
                    'HAATSOO',
                    'HAFO ANO PREMIER RURAL BANK LTD-WIOSO',
                    'HAFO COMMUNITY RURAL BANK LTD-KUKUOM',
                    'HAI RURAL BANK LTD-DODOWA',
                    'HALF ASSINI',
                    'HAMILE',
                    'HANTAMAN RURAL BANK LTD-AGONA NKWANTA',
                    'HAPER ROAD',
                    'HARBOUR AREA',
                    'HARPER ROAD',
                    'HARPER ROAD BRANCH',
                    'HE SEED SAVINGS AND LOANS',
                    'HEAD OFFICE',
                    'HEAD-OFFICE',
                    'HIGH STREET',
                    'HIGH STREET BRANCH',
                    'HIGH STREET TAKORADI',
                    'HIGH STREET-TAKORADI',
                    'HO',
                    'HO AGENCY',
                    'HO BRANCH',
                    'HO MARKET',
                    'HO POLYTECHNIC',
                    'HO POST',
                    'HO POSTBANK',
                    'HOEHOE',
                    'HOHOE',
                    'HOHOE POST',
                    'HOHOE POSTBANK',
                    'HOSPITAL ROAD BRANCH',
                    'HWEDIEM',
                    'HWIDIEM',
                    'HWIDIEM[ B/A]',
                    'IAGYA RURAL BANK LTD-BUSUNYA',
                    'IASEMAN (BOGOSO AREA) RURAL BANK LTD-BOGOSO',
                    'IA-TORYA RURAL BANK LTD-BONSU-NKWANTA',
                    'ICROFIN RURAL BANK LIMITED',
                    'INDEPENDENCE AVENUE',
                    'INDUSTRIAL AREA',
                    'INTAMPO RURAL BANK LTD-KINTAMPO',
                    'INTERNATIONAL BANKING',
                    'IPS',
                    'IPS BRANCH',
                    'IPS LEGON',
                    'IRST GHANA BUILDING SOCIETY- ACCRA',
                    'IRST GHANA BUILDING SOCIETY- KOFORIDUA',
                    'IRST GHANA BUILDING SOCIETY- KUMASI AMAKOM',
                    'IRST GHANA BUILDING SOCIETY- KUMASI SUAME',
                    'IRST GHANA BUILDING SOCIETY- SUNYANI',
                    'IRST GHANA BUILDING SOCIETY- TAKORADI',
                    'IRST GHANA BUILDING SOCIETY-HEAD OFFICE',
                    'IRST GHANA BUILDING SOCIETY-HOHOE',
                    'IRST GHANA BUILDING SOCIETY-TAKORADI',
                    'IRST GHANA BUILDING SOCIETY-TEMA',
                    'ISSALA RURAL BANK LTD-TUMA',
                    'ITIZEN RURAL BANK LTD-ACCRA',
                    'IZAA RURAL BANK LTD-TAMALE',
                    'JACOBU',
                    'JANYAGU',
                    'JAPEKROM',
                    'JAPEKROM/DROBO',
                    'JASIKAN',
                    'JEMA',
                    'JINIJIN',
                    'JIRAPA',
                    'JISONAYILI',
                    'JOMORO RURAL BANK LTD-TIKOBO NO. 1',
                    'JUABEN RURAL BANK LTD-JUABEN',
                    'JUABESO',
                    'JUAPONG',
                    'JUASO',
                    'JUBILEE HOUSE',
                    'JUBILEE HOUSE COCOBOD BUILDING',
                    'JUKWA',
                    'JUNCTION MALL',
                    'JUNCTION MALL BRANCH',
                    'JURAMAN RURAL BANK LTD-KUMASI',
                    'KAASE',
                    'KAASEMAN RURAL BANK LTD-KAASE',
                    'KADE',
                    'KADJEBI',
                    'KAJEBI',
                    'KAKUM RURAL BANK LTD-ELMINA',
                    'KALADAN',
                    'KANASHIE',
                    'KANESHIE',
                    'KANESHIE BRANCH',
                    'KANESHIE INDUSTRIAL AREA',
                    'KANESHIE MAIN',
                    'KANESHIE MARKET',
                    'KANESHIE POST OFFICE',
                    'KANESHIE POST OFFICE BRANCH',
                    'KANESSHIE',
                    'KANTAMANTO',
                    'KANTAMANTO AGENCY',
                    'KANTAMANTO BRANCH',
                    'KARAGA',
                    'KASAPIN',
                    'KASOA',
                    'KASOA BRANCH',
                    'KASOA MAIN',
                    'KASOA MAIN BRANCH',
                    'KASOA MARKET',
                    'KASOA MILLENIUM CITY',
                    'KASOA NEW MARKET',
                    'KATAKYIMAN RURAL BANK LTD-KOMENDA',
                    'KEJETIA',
                    'KEJETIA BRANCH',
                    'KEJETIA- KUMASI',
                    'KENYASE',
                    'KENYASI AGENCY',
                    'KETA',
                    'KETE KRACHI',
                    'KIBI',
                    'KIM BOSOME RURAL BANK LTD-AKIM SWEDRU',
                    'KINTAMPO',
                    'KINTAMPO RURAL BANK LTD-KINTAMPO',
                    'KISSEIMAN BRANCH',
                    'KISSI',
                    'KISSIEMAN',
                    'KNUST',
                    'KNUST BRANCH',
                    'KNUST CAMPUS',
                    'KNUST KUMASI',
                    'KNUTSFORD',
                    'KNUTSFORD AVENUE',
                    'KOFORIDUA',
                    'KOFORIDUA BRANCH',
                    'KOFORIDUA KAMA CENTRE',
                    'KOJO THOMPSON ROAD',
                    'KOKOMLEMLE BRANCH',
                    'KOMENDA',
                    'KOMFO ANOKYE RURAL BANK LTD-WIAMOASE',
                    'KOMLEMLE',
                    'KONGO',
                    'KONONGO',
                    'KORANMAN RURAL BANK LTD-SEIKWA',
                    'KORANZA KWABRE RURAL BANK LTD-AKUMA',
                    'KORKORDZOR',
                    'KORLE BU',
                    'KORLE DUDOR',
                    'KORLE DUDOR BRANCH',
                    'KORLE-BU',
                    'KORLE-BU BRANCH',
                    'KOTI RURAL BANK LTD-ASSIN AKROPONG',
                    'KOTOBABI',
                    'KPADIE',
                    'KPANDAI',
                    'KPANDO',
                    'KPANDU',
                    'KPASSA RURAL BANK LTD-HOHOE',
                    'KPEDZE',
                    'KPETOE',
                    'KPEVE',
                    'KPONE',
                    'KPONG',
                    'KRACHE NKWANTA',
                    'KRANKWANTA RURAL BANK LTD-SUNYANI',
                    'KROFOM',
                    'KROFROM',
                    'KROFUOM AREA RURAL BANK LTD-AKROFUOM',
                    'KRONUM BRANCH',
                    'KUAPEM RURAL BANK LTD-MAMFE',
                    'KUMASI',
                    'KUMASI (ALABAR)',
                    'KUMASI ADUM',
                    'KUMASI -ADUM',
                    'KUMASI AMAKOM',
                    'KUMASI ASAFO',
                    'KUMASI ASAFO BRANCH',
                    'KUMASI ASOKWA',
                    'KUMASI BRANCH',
                    'KUMASI CENT.',
                    'KUMASI CENTRAL',
                    'KUMASI CENTRAL MARKET',
                    'KUMASI HARPER ROAD',
                    'KUMASI MAIN',
                    'KUMASI PREMPEH 11 STREET',
                    'KUMASI PREMPEH STREET',
                    'KUMASI SUAME',
                    'KUMASI TANNOSO',
                    'KUMASI-LAKE  ROAD',
                    'KUMAWUMAN RURAL BANK LTD-KUMAWU',
                    'KUMFIMAN RURAL BANK LTD-ESSUEHYIA',
                    'KWABENYA',
                    'KWABENYA BRANCH',
                    'KWADASO',
                    'KWAEBIBIREM RURAL BANK LTD-ASUOM',
                    'KWAHU PRASO RURAL BANK LTD-KWAHU PRASO',
                    'KWAHU RURAL BANK LTD-KWAHU PEPEASE',
                    'KWAHUTAFO',
                    'KWAMANMAN RURAL BANK LTD-KWAMANG',
                    'KWAME DANSO BRANCH',
                    'KWAME NKRUMAH AVE',
                    'KWAME NKRUMAH CIRCLE',
                    'KWAPONG',
                    'KWASHIEMAN',
                    'KWASHIEMAN BRANCH',
                    'KYEKYEWERE',
                    'KYEM MANSA RURAL BANK LTD-AYIREBI',
                    'KYEPIM RURAL BANK LTD-GOMOA-DAW',
                    'LA',
                    'LA COMMUNITY BANK LTD-LA',
                    'LABONE',
                    'LABONE BRANCH',
                    'LAPAZ',
                    'LAPAZ BRANCH',
                    'LASHIBI',
                    'LASHIBI BRANCH',
                    'LAW COURT COMPLEX',
                    'LAW-COURT',
                    'LAWRA',
                    'LAWRA RURAL BANK LTD-WA',
                    'LEGON',
                    'LEGON MAIN',
                    'LIBERATION ROAD TAKORADI',
                    'LIBERATION ROAD TOKORADI',
                    'LIBERATION ROAD-TAKORADI',
                    'LIBERIA ROAD',
                    'LIBERTY HSE',
                    'LOTTERIES',
                    'LOWER PRA RURAL BANK LTD-SHAMA',
                    'MAAKRO BRANCH',
                    'MAAME KROBO',
                    'MAAMOBI',
                    'MACCARTHY HILL',
                    'MADINA',
                    'MADINA BRANCH',
                    'MADINA CENTRAL BRANCH',
                    'MADINA MAIN BRANCH',
                    'MADINA NEW ROAD BRANCH',
                    'MAKANGO',
                    'MAKOLA',
                    'MAKOLA BRANCH',
                    'MAKOLA SQUARE',
                    'MALLAM',
                    'MALLAM INTERCHANGE',
                    'MALLAM JUNCTION BRANCH',
                    'MAMFE AKUAPIM',
                    'MAMFE BRANCH',
                    'MAMOBI',
                    'MAMOBI BRANCH',
                    'MAMPONG',
                    'MAMPONG AKWAPIM',
                    'MAMPONG ASHANTI',
                    'MAMPROBI',
                    'MAMPROBI POST',
                    'MAMPROBI POSTBANK',
                    'MANANO RURAL BANK LTD-NYINAHIM',
                    'MANET TOWER 3 BRANCH',
                    'MANKESSIM',
                    'MANKESSIM OFFICE COMPLEX',
                    'MANKRASO',
                    'MANSO NKWANTA',
                    'MANSOMAN RURAL BANK LTD-MANSO-AMENFI',
                    'MANYA KROBO RURAL BANK LTD-ODUMASE-KROBO',
                    'MARKET CIRCLE BRANCH',
                    'MARKET CIRCLE TAKORADI',
                    'MASIE WEST RURAL BANK LTD-ANTOAKROM',
                    'MATAHEKO',
                    'MATIN AND KASEI COMMUNITY BANK LTD-KASEI',
                    'MAX MART',
                    'MCCARTHY HILL',
                    'MELCOM',
                    'MENFIMAN RURAL BANK LTD-WASSA AKROPONG',
                    'MEPE AREA RURAL BANK LTD-MEPE',
                    'MERIDIAN BRANCH',
                    'MFANTSIMAN COMMUNITY RURAL BANK LTD-BIRIWA',
                    'MFANTSIPIM',
                    'MICHEL CAMP',
                    'MICROFIN RURAL BANK LIMITED',
                    'MIDLAND SAVING AND LOANS',
                    'MIDLAND SAVINGS & LOANS LTD',
                    'MILE 7/TANTRA',
                    'MIM',
                    'MINISTRIES',
                    'MIOTSO',
                    'MOREE',
                    'MOTOR WAY ROUNDABOUT',
                    'MOTORWAY EXT',
                    'MOTORWAY EXTENSION',
                    'MOTORWAY ROUNDABOUT',
                    'MPATASIE',
                    'MPOHOR',
                    'MPONUA RURAL BANK LTD-AMUANA PRASO',
                    'MPRAESO',
                    'MULTI CREDIT SAVINGS AND LOANS - KUMASI',
                    'MULTICREDIT SAVINGS AND LOANS CO.',
                    'MUMFORD',
                    'MUMUADA RURAL BANK LTD-OSINO',
                    'NAARA RURAL BANK LTD-PAGA',
                    'NAFANA RURAL BANK LTD-SAMPA',
                    'NAGODE',
                    'NANDOM',
                    'NANDOM RURAL BANK LTD-NANDOM',
                    'NAVORONGO',
                    'NAVRONGO',
                    'NBFI-ADVANS GH',
                    'NCHIRAA',
                    'NCR',
                    'NEW ABEKA',
                    'NEW ABIREM',
                    'NEW ABIREM BRANCH',
                    'NEW ABRIEM',
                    'NEW ADUBIASE',
                    'NEW AMAKOM',
                    'NEW DORMAA KOTOKROM',
                    'NEW EDUBIASE',
                    'NEW NINGO',
                    'NEW OFFINSO',
                    'NEW SUAME MAGAZINE',
                    'NEW TAFO',
                    'NEW TOWN',
                    'NEWTOWN',
                    'NEWTOWN ACCRA',
                    'NHYIAESO BRANCH',
                    'NHYIEASO',
                    'NHYIESO',
                    'NIA',
                    'NIA BRANCH',
                    'NIMA',
                    'NIMA BRANCH',
                    'NIMA MAIN BRANCH',
                    'NINGO',
                    'NION RURAL BANK LTD-SENYA BREKU',
                    'NITY RURAL BANK LTD-ZIOPE',
                    'NKAWIE',
                    'NKAWKAW',
                    'NKOBRA WEST (ESIAMA) RURAL BANK LTD-ESIAMA',
                    'NKORANMAN RURAL BANK LTD-SEIKWA',
                    'NKORANSAH',
                    'NKORANZA',
                    'NKORANZA KWABRE RURAL BANK LTD-AKUMA',
                    'NKRANKWANTA',
                    'NKRANKWANTA RURAL BANK LTD-SUNYANI',
                    'NKWAKAW POST',
                    'NKWANTA',
                    'NLO RURAL BANK LTD-ANLOGA',
                    'NOBLE DREAM MICROFINANCE LTD',
                    'NORTH INDUSTRIAL',
                    'NORTH INDUSTRIAL AREA',
                    'NORTH INDUSTRIAL AREA BRANCH',
                    'NORTH KANESHIE',
                    'NORTH RIDGE',
                    'NORTH TONGU RURAL BANK LTD-ADIDOME',
                    'NORTH VOLTA RURAL BANK LTD-GUAMAN',
                    'NSAWAM',
                    'NSOATREMAN RURAL BANK LTD-NSOATRE',
                    'NSUATRE',
                    'NSUFA ASHANTI',
                    'NSUTAMAN RURAL BANK LTD-NSUTA',
                    'NTOROSO',
                    'NUM RURAL BANK LTD-ANUM',
                    'NUNGUA',
                    'NWABIAGYA RURAL BANK LTD-BAREKESE',
                    'NYAKROM RURAL BANK LTD-NYAKROM',
                    'NYAN DENKYIRA RURAL BANK LTD-ENYAN DENKYIRA',
                    'NYANKPALA',
                    'NYANKUMASE AHENKRO RURAL BANK LTD-FANTI NYANKUMASE',
                    'NYIAESO',
                    'NYIAESO AHODWO',
                    'NZEMA MANLE RURAL BANK LTD-AWIEBO',
                    'OBUASI',
                    'ODA',
                    'ODA NKWANTA',
                    'ODORKOR',
                    'ODOTOBRI RURAL BANK LTD-JACOBU',
                    'ODUPONGKPEHE RURAL BANK LTD-KASOA',
                    'ODWEN-ANOMA RURAL BANK LTD-KWEEHWEE',
                    'OENDE RURAL BANK LTD-ZIBILLA',
                    'OFFINSO',
                    'OFFINSO RURAL BANK LTD-KUMASI',
                    'OFFSHORE BANKING',
                    'OFFSHORE BANKING UNIT - GH',
                    'OKAISHIE',
                    'OKAISHIE BRANCH',
                    'OKOFO BRANCH',
                    'OKOMFO ANOKYE RURAL BANK LTD-WIAMOASE',
                    'OKPONGLO',
                    'OKPONGLO BRANCH',
                    'OLA',
                    'OLD NINGO',
                    'OLD SUAME MAGAZINE',
                    'OLD TAFO',
                    'OMAA AREA RURAL BANK LTD-BOMAA',
                    'OMOA AJUMAKO RURAL BANK LTD-AFRANSI',
                    'OMOA RURAL BANK LTD-APAM',
                    'OMORO RURAL BANK LTD-TIKOBO NO. 1',
                    'OMOSADU RURAL BANK LTD',
                    'ONGO RURAL BANK LTD-BOLGATANGA',
                    'ONZALI RURAL BANK LTD-KUMBUNGU',
                    'ONZELE RURAL BANK LTD-JIRAPA',
                    'OPEIBEA HOUSE',
                    'OPERA SQUARE',
                    'OPERA SQUARE BRANCH',
                    'OPPORTUNITY INT. SAVINGS AND LOAN',
                    'OPPORTUNITY INT. SAVINGS AND LOANS',
                    'OPPORTUNITY INTERNATIONAL',
                    'OREIGN',
                    'ORIMANGA RURAL BANK LTD-SAVELEGU',
                    'ORTH TONGU RURAL BANK LTD-ADIDOME',
                    'ORTH VOLTA RURAL BANK LTD-GUAMAN',
                    'OSEI KWADWO KROM',
                    'OSOME FREHO RURAL BANK LTD-KUMASI',
                    'OSOMTWI RURAL BANK LTD-KUNTANASE',
                    'OSU',
                    'OSU  OXFORD BRANCH',
                    'OSU - OXFORD STREET',
                    'OSU - WATSON STREET',
                    'OSU OXFORD ST.',
                    'OSU OXFORD STREET',
                    'OSU WATSON BRANCH',
                    'OTUASEKAN RURAL BANK LTD-KOFIASE',
                    'OUTH AKIM RURAL BANK LTD-NANKESE',
                    'OUTH BIRIM RURAL BANK LTD-ACHIASE',
                    'OWER PRA RURAL BANK LTD-SHAMA',
                    'OXFORD STREET BRANCH',
                    'OYIBI AREA RURAL BANK LIMITED',
                    'PACIFIC SAVINGS AND LOANS LTD',
                    'PAGA',
                    'PALM WINE JUNCTION',
                    'PALMWINE JUNCTION',
                    'PARLIAMENT HOUSE',
                    'PASSA RURAL BANK LTD-HOHOE',
                    'PATASE',
                    'PATRICE LUMUMBA ROAD',
                    'PEKI',
                    'PENTAGON LEGON BRANCH',
                    'PEX BANK - BOLGA CENTRE-BOLGATANGA',
                    'PEX BANK - CAPE COASTCAPE COAST',
                    'PEX BANK - TAMALE CENTRE-TAMALE',
                    'PEX BANK -HEAD OFFICE-SOUTH RIDGE ACCRA',
                    'PEX BANK -HOHOE CENTRE-HOHOE',
                    'PEX BANK KOFORIDUA CENTRE-KOFORIDUA',
                    'PEX BANK -SUNYANI CENTRE-SUNYANI',
                    'PEX BANK -WA CENTRE-WA',
                    'PEX BANKACCRA CENTRE-ACCRA',
                    'PEX BANK-HO CENTRE-HO',
                    'PEX BANK-KUMASIKUMASI',
                    'PEX BANK-TAKORADI CENTRE-TAKORADI',
                    'PEX LINK CENTRE-CEDI HOUSE',
                    'PIG FARM BRANCH',
                    'POKUASE',
                    'POKUASE BRANCH',
                    'PONUA RURAL BANK LTD-AMUANA PRASO',
                    'POST OFFICE SQUARE',
                    'POTSIN',
                    'PPER AMENFI RURAL BANK LTD-ANKWAWSO',
                    'PPER MANYA KRO RURAL BANK LTD-ASESEWA',
                    'PRAMPRAM',
                    'PRANG',
                    'PREMIER TOWERS',
                    'PREMPEH II STREET',
                    'PRESTEA',
                    'PRIVATE BANKING',
                    'PROCREDIT SAVINGS & LOANS',
                    'PUSIGA',
                    'RAKWA BRAMAN RURAL BANK LTD-BRAKWA',
                    'REINSURANCE HOUSE',
                    'REINSURANCE HOUSE BRANCH',
                    'REPUBLIC HOUSE',
                    'RIDGE',
                    'RIDGE BRANCH',
                    'RIDGE TOWERS',
                    'RING ROAD',
                    'RING ROAD BRANCH',
                    'RING ROAD CENTRAL',
                    'RING ROAD CENTRAL BRANCH',
                    'RING ROAD WEST',
                    'ROBO COMMUNITY RURAL BANK LTD-DROBO',
                    'ROMAN HILL',
                    'ROMAN HILL BRANCH',
                    'ROMAN HILL MARKET BRANCH',
                    'RRC',
                    'RRC REMITTANCE CENTRE',
                    'RUSSIA ROAD BRANCH',
                    'SABOBA',
                    'SAFE BOND',
                    'SAFE BOND JUBILEE',
                    'SAFE BOUND JUBILEE',
                    'SAFEBOND',
                    'SAKAMAN',
                    'SAKUMONO',
                    'SAKUMONO BRANCH',
                    'SALAGA',
                    'SALTPOND',
                    'SAMPA',
                    'SAMREBOI',
                    'SANDEMA',
                    'SANKORE',
                    'SANTA MARIA',
                    'SANTASI',
                    'SANTE AKYEM RURAL BANK LTD-JUANSA',
                    'SAVELUGU',
                    'SAWINSO RURAL BANK LTD-SEFWI-ASAWINSO',
                    'SAWLA',
                    'SEFWI BEKWAI',
                    'SEFWI BRANCH',
                    'SEFWI ESSAM',
                    'SEFWI WIAWO',
                    'SEFWI WIAWSO',
                    'SEFWIMAN RURAL BANK LTD-SEFWI-ASAW',
                    'SEFWI-WIASO',
                    'SEGE',
                    'SEKONDI',
                    'SEKYEDUMASI RURAL BANK LTD-SEKYEDUMASI',
                    'SEKYERE RURAL BANK LTD-JAMASI',
                    'SERVICE BRANCH',
                    'SHAI RURAL BANK LTD-DODOWA',
                    'SHIPPERS HOUSE BRANCH',
                    'SILVER STAR',
                    'SINAPI ABA SAVINGS & LOAN',
                    'SINAPI ABA SAVINGS & LOANS',
                    'SISSALA RURAL BANK LTD-TUMA',
                    'SME',
                    'SME CENTRE',
                    'SOATREMAN RURAL BANK LTD-NSOATRE',
                    'SOGAKOPE',
                    'SOKOBAN',
                    'SOKOBAN BRANCH',
                    'SOKORE RURAL BANK LTD-ASOKRE',
                    'SOMANYA',
                    'SONZELE RURAL BANK LTD-JIRAPA',
                    'SOUTH AKIM RURAL BANK LTD-NANKESE',
                    'SOUTH BIRIM RURAL BANK LTD-ACHIASE',
                    'SOUTH INDUSTRIAL AREA',
                    'SOUTH INDUSTRIAL AREA(SIA)',
                    'SOUTH INDUSTRIAL BRANCH',
                    'SOUTH LEGON BRANCH',
                    'SOWUTUOM',
                    'SPINTEX',
                    'SPINTEX BRANCH',
                    'SPINTEX MAIN',
                    'SPINTEX PRESTIGE',
                    'SPINTEX ROAD',
                    'SPINTEX ROAD BRANCH',
                    'SSINMAN RURAL BANK LTD-ASSIN MANSO',
                    'SSNIT HOUSE BRANCH',
                    'ST PETERS CO-OPERATIVE CREDIT UNION',
                    'STADIUM',
                    'STADIUM AMAKOM',
                    'STADIUM POST',
                    'STEWART AVENUE KUMASI',
                    'SUAME',
                    'SUAME BRANCH',
                    'SUAME MAAKRO',
                    'SUBONTEN RURAL BANK LTD-WORAWORA',
                    'SUHUM',
                    'SUHUM RURAL BANK',
                    'SUMA RURAL BANK LTD-SUMA AHENKRO',
                    'SUNYANI',
                    'SUNYANI CENTRAL',
                    'SUNYANI MAIN BRANCH',
                    'SUNYANI NIMPONG',
                    'SUNYANI ODUMASE',
                    'SUNYANI POST OFFICE BRANCH',
                    'SUNYANI POSTBANK',
                    'SUOGYAMAN RURAL BANK LTD-ACCRA',
                    'SUOPRA RURAL BANK LTD-AFOSU',
                    'SUTAMAN RURAL BANK LTD-NSUTA',
                    'SUTIFI RURAL BANK LTD-ACERENSUA',
                    'SWANMILL',
                    'SWEDRU',
                    'SWEDRU BRANCH',
                    'TAFO',
                    'TAFO BRANCH',
                    'TAIFA',
                    'TAKORADI',
                    'TAKORADI - KOKOMPE',
                    'TAKORADI BRANCH',
                    'TAKORADI EFFIEKUMA',
                    'TAKORADI HABOUR BRANCH',
                    'TAKORADI HARBOUR',
                    'TAKORADI HARBOUR ROAD',
                    'TAKORADI KOKOMPE',
                    'TAKORADI MAIN',
                    'TAKORADI MARKET CIRCLE',
                    'TAKORADI MKT CIRCLE',
                    'TAKORADI POST',
                    'TAKORADI POSTBANK',
                    'TAMALE',
                    'TAMALE ABOABO',
                    'TAMALE ABOABO BRANCH',
                    'TAMALE BRANCH',
                    'TAMALE CENTRAL',
                    'TAMALE HOSP ROAD',
                    'TAMALE HOSPITAL ROAD',
                    'TAMALE HOSPITAL ROAD BRANCH',
                    'TAMALE LAMESHEGU',
                    'TAMALE MAIN BRANCH',
                    'TAMALE MARKET',
                    'TANOKROM',
                    'TANOSO',
                    'TANTRA',
                    'TARKORADI MARKET',
                    'TARKWA',
                    'TARKWA BRANCH',
                    'TARKWA MINES',
                    'TEASE',
                    'TECH JUNCTION',
                    'TECHIMAN',
                    'TECHIMAN BRANCH',
                    'TECHIMAN MARKET',
                    'TECHIMAN MARKET BRANCH',
                    'TECHIMAN NORTH BRANCH',
                    'TECHIMAN TIA BRANCH',
                    'TECHIMAN VALLEY VIEW BRANCH',
                    'TECHIMAN WENCHI ROAD BRANCH',
                    'TEMA',
                    'TEMA BRANCH',
                    'TEMA COMM 1',
                    'TEMA COMM 2',
                    'TEMA COMM 4',
                    'TEMA COMM. 25',
                    'TEMA COMM. 6',
                    'TEMA COMMUNITY 1',
                    'TEMA COMMUNITY 1 BRANCH',
                    'TEMA COMMUNITY 2 BRANCH',
                    'TEMA COMMUNITY 25',
                    'TEMA COMMUNITY 25 BRANCH',
                    'TEMA COMMUNITY 6',
                    'TEMA COMMUNITY 9',
                    'TEMA COMMUNITY ONE',
                    'TEMA COMMUNITY TWO',
                    'TEMA DRYDOCK',
                    'TEMA EAST',
                    'TEMA FISHING HABOUR',
                    'TEMA FISHING HARBOUR',
                    'TEMA HABOUR',
                    'TEMA HARBOUR',
                    'TEMA INDUSTRIAL AREA',
                    'TEMA LONG ROOM',
                    'TEMA MAIN',
                    'TEMA MAIN BRANCH',
                    'TEMA MARKET',
                    'TEMA METRO BRANCH',
                    'TEMA OIL REFINERY',
                    'TEMA SAFEBOND',
                    'TEMA SHOPPING MAIL',
                    'TEMA SHOPPING MALL',
                    'TEMPANE BRANCH',
                    'TEPA',
                    'TEPAMAN RURAL BANK LTD - TEPAMAN',
                    'TESANO',
                    'TESANO BRANCH',
                    'TESHIE',
                    'TESHIE BRANCH',
                    'TESHIE NUNGUA',
                    'TETTEH QUARSHIE',
                    'THE SEED SAVINGS AND LOANS',
                    'TIA BRANCH',
                    'TIWA RURAL BANK LTD-KWABENG',
                    'TIZAA RURAL BANK LTD-TAMALE',
                    'TOENDE RURAL BANK LTD-ZIBILLA',
                    'TOLON',
                    'TONGU',
                    'TOR',
                    'TRADE FAIR',
                    'TRADE FAIR BRANCH',
                    'TREASURY',
                    'TREDE',
                    'TRUST TOWERS',
                    'TRUST TOWERS BRANCH',
                    'TSITO',
                    'TSOPOLI',
                    'TSUI BLEOO',
                    'TUASEKAN RURAL BANK LTD-KOFIASE',
                    'TUDU',
                    'TUDU BRANCH',
                    'TUMJU',
                    'TUMU',
                    'TUOBODOM',
                    'TUTU BRANCH',
                    'TWEABAN RURAL BANK LTD-SUNYANI',
                    'TWIFO PRASO',
                    'TWIFO RURAL BANK LTD-TWIFO AGONA',
                    'TWIMA KWANWOMA RURAL BANK LTD-PAKYI NO. 2',
                    'TWIMA MPONUA RURAL BANK LTD-TOASE',
                    'TWIMA RURAL BANK LTD-FOASE',
                    'UABEN RURAL BANK LTD-JUABEN',
                    'UCC',
                    'UEW BRANCH',
                    'UHUM RURAL BANK',
                    'UILSA COMMUNITY BANK LTD-SANDEMA',
                    'UMA RURAL BANK LTD-SUMA AHENKRO',
                    'UMAWUMAN RURAL BANK LTD-KUMAWU',
                    'UMPONG RURAL BANK LTD-OFRAMASE',
                    'UMUADA RURAL BANK LTD-OSINO',
                    'UNDP',
                    'UNION RURAL BANK LTD-SENYA BREKU',
                    'UNION SAVINGS & LOANS',
                    'UNION SAVINGS AND LOANS',
                    'UNION SAVINGS AND LOANS LIMITED',
                    'UNITY RURAL BANK LTD-ZIOPE',
                    'UNIV. OF CAPE COAST BRANCH',
                    'UNIVERSITY OF CAPE COAST',
                    'UNIVERSITY OF CAPE COAST BRANCH',
                    'UNIVERSITY OF GHANA BRANCH',
                    'UPPER AMENFI RURAL BANK LTD-ANKWAWSO',
                    'UPPER MANYA KRO RURAL BANK LTD-ASESEWA',
                    'UTAWU RURAL BANK LTD-HO',
                    'UTRAK SAVINGS AND LOANS',
                    'UWUULONSO RURAL BANK LTD-TAMALE',
                    'VAKPO',
                    'VALLEY VIEW',
                    'VALLEY VIEW UNIVERSITY- TECHIMAN',
                    'VENOR RURAL BANK LTD-AKATSI',
                    'WA',
                    'WA BRANCH',
                    'WABIAGYA RURAL BANK LTD-BAREKESE',
                    'WAEBIBIREM RURAL BANK LTD-ASUOM',
                    'WAHU PRASO RURAL BANK LTD-KWAHU PRASO',
                    'WAHU RURAL BANK LTD-KWAHU PEPEASE',
                    'WALEWALE',
                    'WAMANMAN RURAL BANK LTD-KWAMANG',
                    'WAMFIE',
                    'WAMFIE RURAL BANK LTD-WAMFIE',
                    'WASSA MANSO',
                    'WECHIAU',
                    'WEIJA',
                    'WEIJA BRANCH',
                    'WENCHI',
                    'WENCHI RURAL BANK LTD',
                    'WEST HILLS MALL',
                    'WEST LANDS',
                    'WEST MANPRUSI COMMUNITY BANK LTD-WALEWALE',
                    'WESTERN HILL',
                    'WESTERN RURAL BANK LTD-WASSA AKROPONG',
                    'WESTLANDS',
                    'WETO RURAL BANK LTD-KPEVE',
                    'WIDANA',
                    'WIFO RURAL BANK LTD-TWIFO AGONA',
                    'WINNEBA',
                    'WINNEBA BRANCH',
                    'WINNEBA RD',
                    'WINNEBA ROAD',
                    'WISCONSIN',
                    'WISCONSIN BRANCH',
                    'WOMANS WORLD BANKING',
                    'WOMENS WORLD BANK GHANA SAVINGS AND LOANS',
                    'WOMENS WORLD BANKING',
                    'WULENSI',
                    'WURIYENGA',
                    'WUTU EMASA RURAL BANK LTD-AWUMASA',
                    'YAA ASANTEWAA RURAL BANK LTD',
                    'YAKROM RURAL BANK LTD-NYAKROM',
                    'YANKUMASE AHENKRO RURAL BANK LTD-FANTI NYANKUMASE',
                    'YAPRA RURAL BANK LTD-PRANG',
                    'YEJI',
                    'YENDI',
                    'YESU NKWA',
                    'YIBI AREA RURAL BANK LIMITED',
                    'YUNYOO',
                    'ZABZUGU RURAL BANK LTD',
                    'ZEBILLA',
                    'ZEMA MANLE RURAL BANK LTD-AWIEBO',
                    'ZENITH BANK (GH) LTD-SUNYANI',
                    'ZENU',
                    'ZENU BRANCH',
                    'ZONGO JUNCTION',
                  ],
                  publishChange: true,
                  readonly: false,
                  tooltip: 'Account Branch Name',
                  type: 'field',
                  uid: '503a71583f1182e2',
                },
                {
                  id: 'account-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Account Number',
                  uid: '495c881bcf57de23',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: true,
          label: 'System List',
          uid: 'd1ac4ed6d65c6c5b',
          content: [],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas',
              uid: 'b25a984636d42a56',
              content:
                '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'b9956967dff482d6',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'afc13848944f37c6',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd768749ed81c8eec',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '2aea10aeb7915580',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Payment Details',
    uri: 'transition/quote',
    template: 'transition-lives-assured-screen',
    class: 'transition-payment-details',
  },
  'stop-order-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: '799042e605ead6bd',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'stop-order-details',
          type: 'list',
          readonly: false,
          label: 'Stop Order Details',
          uid: '6bd977fde75cac31',
          content: [
            {
              id: 'employer-organisation',
              type: 'field',
              elementType: 'select',
              readonly: false,
              label: 'Employer Organisation',
              uid: '583c1096a7303045',
              content: '',
              publishChange: true,
              errors: ['*'],
              options: [
                '',
                'Abokobi Area Rural Bank Staff',
                'Accra Metro Assembly',
                'Advent Press',
                'African Regent Hotel',
                'Agave Rural Bank',
                'Agric Development Bank',
                'Ahafo Ano Premier Rural Bank',
                'Akaa Security Services',
                'Akwapem Rural Bank',
                'Aluworks',
                'Ama Dansowaa Clinic',
                'Amanano Rural Bank',
                'Amansie West Rural Bank',
                'Amantin & Kasei Community Bank',
                'Antrak Ghana Ltd',
                'Anum Rural Bank Ltd',
                'Apex Bank',
                'Ashante Akyem Rural Bank',
                'Asokore Rural Bank Ltd - Kumasi',
                'Asutifi Rural Bank Limited',
                'Atlantic Int. Holding Co',
                'Atwima Kwanwoma Rural Bank',
                'Atwima Rural Bank',
                'Auto Parts Limited',
                'Awutu Emasa Rural Bank',
                'Ayrton Drug Manufacturing Limited',
                'Bank of Ghana',
                'Baptist Medical Centre',
                'Bible Society of Ghana',
                'Bonzali Rural Bank',
                'Bosomtwe Rb',
                'Bureau of National Investigations',
                'Capital Rural Bank',
                'Cejose Wisdom Int. School',
                'Ceps',
                'Chemico Limited',
                'Chirano Gold Mines',
                'Christ Ebenezer',
                'Christian Service University College - K',
                'Church Hill of God',
                'Cocoa Marketiing Company Ltd',
                'Cocoa Processing Comp',
                'Controller',
                'Cssvd Control Unit',
                'Dangme Rural Bank Ltd - Staff',
                'De Youngsters International School Ltd',
                'Deoke Foundation Schools',
                'Derma Area Rural Bank',
                'Dizengoff Ghana Ltd',
                'Dynamic Insurance Brokers',
                'Ebennezer Osei Brenya Enterprise',
                'Ejuraman Rural Bank',
                'Englebert School',
                'Enterprise Funeral Services',
                'Enterprise Group Ltd',
                'Enterprise Insurance',
                'Enterprise Life Reps',
                'Enterprise Life Staff',
                'Enterprise Properties Ltd',
                'Enterprise Trustees Limited',
                'Epa',
                'Eskay Therapeutics Ltd',
                'Expandable Polystyrene Products Ltd',
                'Fiagya Rural Bank Ltd',
                'Fiesta Royale Hotel',
                'Forces Pay Office',
                'Ga East Municipal Assembly',
                'Ga Rural Bank',
                'Gafco',
                'Garden City Savings & Loans Limited',
                'Gcb Bank Ltd Staff',
                'Ghacem',
                'Ghana Airport Company Ltd.',
                'Ghana Cement',
                'Ghana Chamber of Mines',
                'Ghana Civil Aviation Authority',
                'Ghana Cocoa Board',
                'Ghana Grid Company',
                'Ghana Heavy Equipment Limited',
                'Ghana Link Network Services Ltd',
                'Ghana Maritime Authority',
                'Ghana Medical School',
                'Ghana Oil Co. Ltd',
                'Ghana Police Service',
                'Ghana Post',
                'Ghana Railway Co. Ltd',
                'Ghana Re Company Limited',
                'Ghana Standard Board',
                'Ghana Union Conference of s.d.a.',
                'Ghana Water Company Ltd',
                'Gihoc Distilleries Company Limited',
                'Gimpa',
                'Golden Exotics Ltd',
                'Goldengate Services Ltd',
                'Grace Baptist School - Kumasi',
                'Guiness Ghana Ltd',
                'Gwcl - Accra East',
                'Gwcl - Accra West',
                'Gwcl - Ashanti North',
                'Gwcl - Ashanti Production',
                'Gwcl - Ashanti South',
                'Gwcl - Head Office',
                'Gwcl - Sunyani',
                'Gwcl - Takoradi',
                'Gwcl - Tema',
                'Gwcl Greater Accra Region Production',
                'Hobats Clinic',
                'Holiday Inn Accra',
                'Home Finance Company Bank Ltd',
                'House of Compassion Ministries',
                'Internal Revenue Service',
                'Japan Motors Trading Company',
                'Juaben Rural Bank',
                'Jubilee Shipping Services Gh Ltd',
                'k.n.u.s.t',
                'Kaaseman Rural Bank Ltd',
                'Kessben',
                'Kingsgroup of Companies',
                'Kintampo Health Research Centre',
                'Korle Bu Teaching Hospital',
                'Krane Contsruction Co. Ltd',
                'Krobo Danish Association',
                'Kuapa Kokoo',
                'Kumawuman Rural Bank',
                'Kumawuman Rural Bnk',
                'Kwamaman Rural Bank',
                'Labadi Beach Hotel',
                'La Nkwantanang Madina Municipal Assembly',
                'Living Star School',
                'Lordship Insurance Brokers',
                'Lower Pra',
                'Maxam Ghana Ltd',
                'Mechanical Lloyd',
                'Metromass',
                'Mobitel',
                'Mondial Veneer Gh. Ltd',
                'Mumuada Rural Bank',
                'Nafana Rural Bank Ltd',
                'National Security',
                'Nexans',
                'Nsoatreman Rural Bank',
                'Nthc Properties Ltd',
                'Nwabiagya Rural Bank',
                'Okomfo Anokye Rural Bank Staff',
                'Opportunity International s.a Savings An',
                'Parliament',
                'Pbc Ltd',
                'Pentecost University College',
                'Phyto Riker',
                'Poly Products',
                "Presbyterian Women's Center - Abokobi",
                'Prince of Peace',
                'Quality Control Division',
                'Quality Control Division (Cocobod)',
                'Regional Maritime Academy',
                'Ridge Church School',
                'Safebound Company Limited - Tema',
                'Sakworg Company Ltd',
                'Samartex Timber and Plywood Company',
                'Sandvik Mining and Construction Limited',
                'Scanbech Ghana Ltd',
                'Sdv Ghana',
                'Securities Discount Company Limited',
                'Sekyedumase Rural Bank',
                'Sekyere Rural Bank',
                'Sgs Laboratory Services',
                'Sg Ssb',
                'Silver Star Auto Ltd',
                'Sinapi Aba Trust',
                'Sofaamy Company Limited',
                "Sos Children's Village, Ghana",
                'South Birim Rural Bank',
                'Special Ice Company Ltd',
                'Ssnit',
                'St Ambrose College',
                "St Michael's Hospital, Pramso",
                'Stellar Logistic',
                'Sunyani Cluster Icps',
                'Takoradi Flour Mill Ltd',
                'Takoradi Int. Co.',
                'Tct',
                'Tema Development Corp.',
                'Tema Parents Association School',
                'Tesano Baptist Church',
                'The Church of Pentecost',
                'Toende Rural Bank',
                'Trasacco',
                'Type Company Ltd',
                'Unicredit Ghana Limited',
                'Unilever',
                'University College of Education - Winneba, kumasi',
                'University for Development Studies',
                'University of Energy and Natural Resources (Uenr)',
                'University of Ghana - Legon',
                'Upper Amenfi Rural Bank',
                'Upper Manya Kro Rural Bank',
                'Utrak Savings and Loans',
                'Valley View',
                'Valley View University Basic School',
                'Vat Service',
                'Volta Hotel',
                'Volta River Authority',
                'Waec - Headquarters',
                'Waec - Main',
                'Wenchi Rural Bank Ltd',
                'West Africa Mills Co. Ltd',
                'Weto Rural Bank',
                'Winners Chapel, Ghana',
                'Womens World Banking',
                'Yaakson Herbal Centre',
                'Yarsako',
              ],
            },
            {
              id: 'employee-number',
              type: 'field',
              elementType: 'input',
              readonly: false,
              label: 'Employee Number',
              uid: '17ff314b6165c883',
              content: '',
              publishChange: true,
              errors: ['*'],
              inputType: 'text',
            },
          ],
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: true,
          label: 'System List',
          uid: 'd1ac4ed6d65c6c5b',
          content: [],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas',
              uid: 'b25a984636d42a56',
              content:
                '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'b9956967dff482d6',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'afc13848944f37c6',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd768749ed81c8eec',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '2aea10aeb7915580',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Payment Details',
    uri: 'transition/quote',
    template: 'transition-lives-assured-screen',
    class: 'transition-payment-details',
  },
  'mobile-wallet-details': {
    text: [],
    buttons: [
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'payment-details',
      type: 'list',
      readonly: false,
      label: 'Payment Details',
      uid: '7fed6be94204fe8b',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '53606e9c53fc5262',
          content: '<h2>Payment Details</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '493a034ea85c537a',
          content:
            '<p>Please complete your preferred payment method and payment details below.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '373c5662bc08cf41',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'system-list',
          type: 'list',
          readonly: false,
          label: 'System List',
          uid: '51ec63fbc00239ee',
          content: [
            {
              id: 'mobile-wallet-details',
              type: 'list',
              readonly: false,
              label: 'Mobile Wallet Details',
              uid: '2d34ee1c0b75f4a2',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '7577327f9a279ee2',
                  content: '<p>Please provide your mobile wallet details</p>\n',
                },
                {
                  id: 'mobile-ref',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Mobile Ref',
                  uid: '4328f272520d0f35',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Mobile Ref',
                  options: ['', 'Mobile-1', 'Mobile-2', 'Mobile-3'],
                },
                {
                  id: 'mobile-wallet-network-provider',
                  type: 'field',
                  elementType: 'select',
                  readonly: false,
                  label: 'Mobile Wallet Network Provider',
                  uid: '3a6d7817942bbe73',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Mobile Wallet Network Provider',
                  options: [
                    '',
                    'Vodafone',
                    'Mtn',
                    'Tigo',
                    'Airtel',
                    'Expresso',
                    'Glo Mobile',
                  ],
                },
                {
                  id: 'mobile-wallet-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: false,
                  label: 'Mobile Wallet Number',
                  uid: '165034a17f3ef9dd',
                  content: '',
                  publishChange: true,
                  errors: ['*'],
                  tooltip: 'Mobile Wallet Number',
                  inputType: 'text',
                },
              ],
            },
          ],
        },
        {
          id: 'signature',
          type: 'list',
          readonly: false,
          label: 'Signature',
          uid: '1848a6126f8f1403',
          content: [
            {
              id: 'interactive-canvas-html',
              type: 'component',
              component: 'InteractiveCanvas',
              readonly: false,
              label: 'Interactive Canvas',
              uid: 'b25a984636d42a56',
              content:
                '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'b9956967dff482d6',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'afc13848944f37c6',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: 'd768749ed81c8eec',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '2aea10aeb7915580',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'fb3a74d8b4c60af2',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Payment Details',
    uri: 'transition/quote',
    template: 'transition-lives-assured-screen',
    class: 'transition-payment-details',
  },
  'upload-documents': {
    text: [],
    buttons: [
      {
        label: 'Upload ID document',
        id: 'upload-id-document',
        uid: '69a53b6758f4ff80',
        control: false,
      },
      {
        label: 'Next',
        id: 'next',
        uid: '26ca340069ec84e5',
        control: true,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'upload-documents',
      type: 'list',
      readonly: true,
      label: 'Upload Documents',
      uid: 'fa95bde5d70a5735',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '2dd71fd55a00cef9',
          content: '<h2>Upload Documents</h2>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f4179312612d1ce4',
          content:
            '<p>Please upload the necessary documentation or proceed to the next page if you would like to provide it later.</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: 'e567849ef903ec0e',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='done clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'documents-list',
          type: 'list',
          readonly: true,
          label: 'Documents List',
          uid: '8a30a43b57bb332b',
          content: [
            {
              id: 'system-field-outcome',
              type: 'html',
              readonly: true,
              label: '',
              uid: '7721dd56ec3e43de',
              content:
                "<p><a href='#upload-id-document' class=''>ID Document <span>Re Upload</span></a></p>\n",
            },
          ],
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'd56a07c519da3350',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: 'a856aa4d3af4472e',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '8928432143c5d39b',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '25157e1a71993bb8',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'abed9ed6fd97427b',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Upload Documents',
    uri: 'transition/upload-documents',
    template: 'transition-app-template',
    class: 'transition-upload-documents',
  },
  'upload-document-pages': {
    modal: true,
    buttons: [
      {
        control: false,
        label: 'Add Page',
        id: 'add-page',
        uid: '1a5450d98db152d6',
      },
      {
        control: true,
        label: 'Abort',
        id: 'abort',
        uid: 'e11279c7f15a77ea',
      },
      {
        control: true,
        label: 'Continue',
        id: 'continue',
        uid: '0d54090d869303f6',
      },
    ],
    item: {
      content: [
        {
          content:
            '<p>Please upload your ID Document below. If it consists of multiple pages, please upload all of them together.</p>\n',
          id: 'system-field-outcome',
          type: 'html',
          readonly: true,
          label: '',
          uid: '8872705861783d2d',
        },
        {
          content: [],
          id: 'uploads',
          type: 'table',
          readonly: false,
          label: 'Uploads',
          uid: '2d999fbaaefb947c',
        },
        {
          content:
            "<p><a class='button add-page-button' href='#add-page'>Add Page</a></p>\n",
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'a47ce0e3f28e09c5',
        },
      ],
      id: 'upload-section',
      type: 'list',
      readonly: false,
      label: 'Upload Section',
      uid: '74b77d523e9f9b6d',
    },
    class: 'upload-layout',
    context: 'Upload Layout',
    template: '',
    text: [],
    title: 'Public Access \n Welcome to Elac',
    uri: 'upload-document/file/new',
  },
  'acceptance-screen': {
    text: [],
    buttons: [
      {
        label: 'Submit',
        id: 'submit',
        uid: 'ef8243ce592928b2',
        control: false,
      },
      {
        label: 'Back',
        id: 'back',
        uid: '1303e2b2da021d46',
        control: true,
      },
      {
        label: 'Cancel',
        id: 'cancel',
        uid: 'e25c3188a733209e',
        control: true,
      },
    ],
    item: {
      id: 'acceptance',
      type: 'list',
      readonly: false,
      label: 'Acceptance',
      uid: '3011bf6567ede275',
      content: [
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: 'f9d0e1f1ebff8a2a',
          content: '<h1>Summary</h1>\n',
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '8b470d282f194b34',
          content: '<p>Please review the information below</p>\n',
        },
        {
          id: 'output-html',
          type: 'html',
          readonly: true,
          label: 'Output',
          uid: '65dbe261db324f63',
          content:
            "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='done clickable'><a href='#underwriting'>Underwriting</a></li>\n<li class='done clickable'><a href='#payment'>Payment</a></li>\n<li class='done clickable'><a href='#uploads'>Uploads</a></li>\n<li class='done clickable'><a href='#summary'>Summary</a></li>\n</ol>",
        },
        {
          id: 'summary',
          type: 'list',
          readonly: true,
          label: 'Summary',
          uid: '37a2b1a42f29646b',
          content: [
            {
              id: 'contract-id',
              type: 'field',
              elementType: 'input',
              readonly: true,
              label: 'Application Reference Number',
              uid: '0d3a5727942b5c07',
              content: '',
              inputType: 'text',
            },
            {
              id: 'life-assured-identification',
              type: 'list',
              readonly: true,
              label: 'Life Assured Identification',
              uid: 'c5c34cef76f97841',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: 'a74f8fe14cd19eaa',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: 'b03a78ec3502f9bf',
                  content: 's',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '4fbcb5f5033fa4a4',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'marital-status',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Marital Status',
                  uid: '0e8075522a13b595',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'gender',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Gender',
                  uid: '25970a93188b88d4',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'title',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Title',
                  uid: 'ed95cacac04323fd',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'ghanaian',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Ghanaian',
                  uid: '9456d02f16087d0e',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'other-nationality',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Other Nationality',
                  uid: '2f424b4b0d898ac1',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'idpassport-number',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'ID Number',
                  uid: 'fecc9856412d6b21',
                  content: '',
                  inputType: 'number',
                },
              ],
            },
            {
              id: 'life-assured-contact-details',
              type: 'list',
              readonly: true,
              label: 'Life Assured Contact Details',
              uid: 'a8988a90cff8814d',
              content: [
                {
                  id: 'cell-phone',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Cell Phone',
                  uid: '4f9e98cae52cd1fd',
                  content: '',
                  inputType: 'tel',
                },
                {
                  id: 'email',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Email',
                  uid: '1891b94b5104447e',
                  content: '',
                  inputType: 'email',
                },
              ],
            },
            {
              id: 'life-assured-postal-address',
              type: 'list',
              readonly: true,
              label: 'Life Assured Postal Address',
              uid: '4ee17cb76527033a',
              content: [
                {
                  id: 'po-box-or-private-bag',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'PO Box Or Private Bag',
                  uid: 'ab67f6de93588c9a',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'region',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Region',
                  uid: '5f8871613be9c512',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'town',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Town',
                  uid: 'a7dfcc0e03f84774',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'trustee-identification',
              type: 'list',
              readonly: true,
              label: 'Trustee Identification',
              uid: '81fcc6f07f014db7',
              content: [
                {
                  id: 'first-names',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'First Names',
                  uid: '9f8cca564f33dafb',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'surname',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Surname',
                  uid: 'd79092907e11ab24',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'date-of-birth',
                  type: 'integer',
                  elementType: 'input',
                  readonly: true,
                  label: 'Date Of Birth',
                  uid: '890da04c904445a0',
                  content: '',
                  inputType: 'number',
                },
                {
                  id: 'cell-phone',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Cell Phone',
                  uid: '6360b42285a0f5e2',
                  content: '',
                  inputType: 'tel',
                },
                {
                  id: 'relationship',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Relationship',
                  uid: 'bed853c124158693',
                  content: '',
                  inputType: 'text',
                },
                {
                  id: 'title',
                  type: 'field',
                  elementType: 'input',
                  readonly: true,
                  label: 'Title',
                  uid: '487e9507ab0315cd',
                  content: '',
                  inputType: 'text',
                },
              ],
            },
            {
              id: 'payment-details',
              type: 'list',
              readonly: true,
              label: 'Payment Details',
              uid: 'd2994131363640e0',
              content: [],
            },
          ],
        },
        {
          id: 'system-constant',
          type: 'html',
          readonly: true,
          label: '',
          uid: '659263c7132d2858',
          content: '<br/>',
        },
        {
          id: 'interactive-canvas-html',
          type: 'component',
          component: 'InteractiveCanvas',
          readonly: false,
          label: 'Interactive Canvas',
          uid: '1fcad0e41194c3d1',
          content:
            '<h2>Sign in the area below</h2>\n<p>By signing in the allocated space below, you indicate that you confirm that the information above is correct and that you accept the Terms and Conditions</p>\n<div class=`interactive-canvas` data-message=`Please sign in the area below`></div>',
        },
        {
          id: 'quotation-panel',
          type: 'list',
          readonly: true,
          label: 'Quotation Panel',
          uid: 'bda1b5fb9230789e',
          content: [
            {
              id: 'quotation-information',
              type: 'list',
              readonly: true,
              label: 'Quotation Information',
              uid: '65c53d404e059a98',
              content: [
                {
                  id: 'system-constant',
                  type: 'html',
                  readonly: true,
                  label: '',
                  uid: '4e245e2f2bd09103',
                  content: '<p>Transition Plan</p>\n',
                },
                {
                  id: 'benefit-rate',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Benefit Rate',
                  uid: '28a6cd68ea42c9c9',
                  content: '0.00',
                  inputType: 'number',
                },
                {
                  id: 'premium',
                  type: 'amount',
                  elementType: 'input',
                  readonly: true,
                  label: 'Premium',
                  uid: 'bbd7cd4827d9d0c8',
                  content: '0.00',
                  inputType: 'number',
                },
              ],
            },
          ],
        },
      ],
    },
    title: 'Public Access \n Welcome to Elac',
    context: 'TRANSITION Acceptance Screen',
    uri: 'transition/acceptance',
    template: 'transition-acceptance-screen',
    class: 'transition-acceptance-screen',
  },
  completed: {
    modal: true,
    text: [],
    buttons: [
      {
        label: 'Continue',
        id: 'continue',
        uid: 'fb11ce7f64c71481',
        control: true,
      },
    ],
    item: {
      id: 'message',
      type: 'text',
      readonly: true,
      label: 'Message',
      uid: '95c15702a2e492f8',
      content: ['Application completed successfully.'],
    },
    context: '',
    title: 'Public Access \n Welcome to Elac',
  },
}

export const familyMemberTablePrefix = [
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '0bc795d3e0cb7f34',
    content: '<h2>Additional Lives Details</h2>\n',
  },
  {
    id: 'system-constant',
    type: 'html',
    readonly: true,
    label: '',
    uid: '4780eecde04adec3',
    content:
      '<p>Please complete the details for your additional lives below</p>\n',
  },
  {
    id: 'output-html',
    type: 'html',
    readonly: true,
    label: 'Output',
    uid: '61f48521f562ddce',
    content:
      "<ol class='progress-indicator'>\n<li class='done clickable'><a href='#cover'>Cover</a></li>\n<li class='done clickable'><a href='#additional'>Additional</a></li>\n<li class='done clickable'><a href='#details'>Details</a></li>\n<li class='clickable'><a href='#payment'>Payment</a></li>\n<li class='clickable'><a href='#uploads'>Uploads</a></li>\n<li class='clickable'><a href='#summary'>Summary</a></li>\n</ol>",
  },
]

export const familyMemberItem = (f, counter) => ({
  id: `life-${counter}`,
  type: 'list',
  readonly: false,
  label: f.relationship,
  uid: '5432e61f6f8668e2',
  content: [
    {
      id: 'system-field-outcome',
      type: 'html',
      readonly: true,
      label: '',
      uid: '75c90bfb45d97833',
      content: `<p>Please provide the following information for your <strong>${f.relationship}</strong> aged <strong>${f['age-of-member']}</strong>.</p>\n`,
    },
    {
      id: `first-names-${counter}`,
      type: 'field',
      elementType: 'input',
      readonly: false,
      label: 'First Names',
      uid: '74a52c05968e5b1d',
      content: f['first-names'] || '',
      publishChange: true,
      errors: f['first-names'] ? [] : ['*'],
      inputType: 'text',
    },
    {
      id: `surname-${counter}`,
      type: 'field',
      elementType: 'input',
      readonly: false,
      label: 'Surname',
      uid: '28e588b2c62ec549',
      content: f.surname || '',
      publishChange: true,
      errors: f.surname ? [] : ['*'],
      inputType: 'text',
    },
    {
      id: `date-of-birth-${counter}`,
      type: 'component',
      elementType: 'input',
      readonly: false,
      label: 'Date Of Birth',
      uid: 'e1ad00cce709faf3',
      content: f['date-of-birth'] || '',
      errors: f['date-of-birth'] ? [] : ['*'],
      publishChange: true,
      inputType: 'date',
      component: 'DateSelector',
      maxYear: dayjs().year(),
    },
    {
      id: `gender-${counter}`,
      type: 'field',
      elementType: 'input',
      readonly: true,
      label: 'Gender',
      uid: 'b6a1d11a9d8d8daf',
      content: f.gender || '',
      tooltip: 'Gender',
      inputType: 'text',
      options: ['', 'Female', 'Male'],
    },
    {
      id: 'quotation-panel',
      type: 'list',
      readonly: true,
      label: 'Quotation Panel',
      uid: 'f8dc2ab189e41a64',
      content: [
        {
          id: 'quotation-information',
          type: 'list',
          readonly: true,
          label: 'Quotation Information',
          uid: '2b556807a099b394',
          content: [
            {
              id: 'system-constant',
              type: 'html',
              readonly: true,
              label: '',
              uid: '96fbafea70d27dc6',
              content: '<p>Transition Plan</p>\n',
            },
            {
              id: 'benefit-rate',
              type: 'amount',
              elementType: 'input',
              readonly: true,
              label: 'Benefit Rate',
              uid: 'deeffb58b9038029',
              content: '0.00',
              inputType: 'number',
            },
            {
              id: 'premium',
              type: 'amount',
              elementType: 'input',
              readonly: true,
              label: 'Premium',
              uid: 'b9f996d5dc386fec',
              content: '0.00',
              inputType: 'number',
            },
          ],
        },
      ],
    },
  ],
})

let ageRange = () => {
  const cached = {}
  return (start, end) => {
    if (start > end) {
      start = end
    }
    const k = `[${start}-${end}]`
    if (k in cached) {
      return cached[k]
    }
    const range = ['', `${start}`]
    for (let val = start + 1; val <= end; val++) {
      range.push(`${val}`)
    }
    cached[k] = range
    return range
  }
}
ageRange = ageRange()

// Family member menu
export const familyMemberOptions = (age) => ({
  Spouse: {
    options: ageRange(18, 100),
  },
  Child: {
    options: ageRange(1, 21),
  },
  //AGE DIFFERENCE BETWEEN LIFE ASSURED AND PARENTS = MINIMUM OF 13 YEARS
  'Parent or In-Laws': {
    Mother: {
      options: ageRange(age + 13, 100),
    },
    'Mother in law': {
      options: ageRange(age + 13, 100),
    },
    Father: {
      options: ageRange(age + 13, 100),
    },
    'Father in law': {
      options: ageRange(age + 13, 100),
    },
  },
  //AGE DIFFERENCE BETWEEN LIFE ASSURED AND GRAND PARENTS = 26 YEARS
  Grandparents: {
    Grandmother: {
      options: ageRange(age + 26, 100),
    },
    Grandfather: {
      options: ageRange(age + 26, 100),
    },
  },
  'Step Parents': {
    'Step mother': {
      options: ageRange(age + 13, 100),
    },
    'Step father': {
      options: ageRange(age + 13, 100),
    },
  },
  Siblings: {
    Sister: {
      options: ageRange(1, 100),
    },
    Brother: {
      options: ageRange(1, 100),
    },
  },
  //AGE DIFFERENCE BETWEEN LIFE ASSURED AND GAURDIAN = 16 YEARS
  Guardian: {
    options: ageRange(age + 16, 100),
  },
})
export const familyMemberLabels = Object.keys(familyMemberOptions(0))

export const isMultipleOccuranceRelationship = (relationship) =>
  ['Spouse'].indexOf(relationship) < 0

export const multipleOccurancesExist = (life, lives) =>
  isMultipleOccuranceRelationship(life.relationship) &&
  lives.reduce(
    (c, l) => (l.relationship === life.relationship ? c + 1 : c),
    0
  ) > 1

const findOccurance = (life, position, lives) => {
  let occuranceString = ''
  if (multipleOccurancesExist(life, lives)) {
    let occurance = 1
    for (let i = position - 1; i >= 0; i--) {
      if (lives[i].relationship === life.relationship) {
        occurance += 1
      }
    }
    occuranceString = ` ${occurance}`
  }
  return occuranceString
}

export const additionalLife = (life, position, lives) => {
  const lifeRelationship = `${life.relationship}${findOccurance(
    life,
    position,
    lives
  )}`
  return [
    createItem('Relationship', {
      content: lifeRelationship,
      elementType: 'input',
      inputType: 'text',
      readonly: true,
      type: 'field',
    }),
    createItem('Age', {
      content: life['age-of-member'],
      elementType: 'input',
      inputType: 'number',
      readonly: true,
      type: 'integer',
    }),
    createItem('system-field-outcome', {
      content: `<p><a class="remove" href="#remove-family#${slugify(
        lifeRelationship
      )}">Remove</a><a class="edit" href="#edit-family#${slugify(
        lifeRelationship
      )}">Edit</a></p>\n`,
      label: '',
      readonly: true,
      type: 'html',
    }),
  ]
}

export const buttonFromLifeAssured = (life, position, lives) =>
  createButton(`${life.relationship}${findOccurance(life, position, lives)}`)

export const idFromLifeAssured = (life, position, lives) =>
  slugify(`${life.relationship}${findOccurance(life, position, lives)}`)

export const createFamilyMember = (relationship, ageofmember, gender) => ({
  relationship,
  'age-of-member': ageofmember,
  gender,
  'first-names': null,
  surname: null,
  'date-of-birth': null,
})

export const paymentDetailsSummary = (form) => {
  if (form['mobile-wallet'] === 'Y') {
    return {
      id: 'mobile-wallet-details',
      type: 'list',
      readonly: true,
      label: 'Mobile Wallet Details',
      content: [
        {
          id: 'mobile-wallet-number',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Mobile Wallet Number',
          uid: '96d79859b70f1d61',
          content: '',
          inputType: 'text',
        },
        {
          id: 'mobile-wallet-network-provider',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Mobile Wallet Network Provider',
          uid: 'e15ab36d3f397c2e',
          content: '',
          inputType: 'text',
        },
      ],
    }
  } else if (form['debit-order'] === 'Y') {
    return {
      id: 'payment-bank-details',
      type: 'list',
      readonly: true,
      label: 'Payment Bank Details',
      content: [
        {
          id: 'account-holder-name',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Account Holder Name',
          uid: 'c48fe6bcd83a0b4a',
          content: '',
          inputType: 'text',
        },
        {
          id: 'account-entity-name',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Account Entity Name',
          uid: '887f2c3da9067907',
          content: '',
          inputType: 'text',
        },
        {
          id: 'account-type',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Account Type',
          uid: '8de41e5b5f22dfaa',
          content: '',
          inputType: 'text',
        },
        {
          id: 'account-branch-name',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Account Branch Name',
          uid: 'faebf7bb7f978ec3',
          content: '',
          inputType: 'text',
        },
        {
          id: 'account-number',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Account Number',
          uid: '27269012310a5430',
          content: '',
          inputType: 'text',
        },
      ],
    }
  } else if (form['stop-order'] === 'Y') {
    return {
      id: 'payment-employment-details',
      type: 'list',
      readonly: true,
      label: 'Payer Employment Details',
      content: [
        {
          id: 'employer-organisation',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Employer Organisation',
          uid: '781441cc7b190193',
          content: '',
          inputType: 'text',
        },
        {
          id: 'employee-number',
          type: 'field',
          elementType: 'input',
          readonly: true,
          label: 'Employee Number',
          uid: '27581bcc2706c489',
          content: '',
          inputType: 'text',
        },
      ],
    }
  } else {
    return {}
  }
}
